// import React, { useEffect, useState } from "react";
// import { Edit, Trash2 } from "lucide-react";
// import { FaSearch } from "react-icons/fa";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import Apiurl from "../../environment/Apiurl";

// const Add_GeneralBill = () => {
//   const navigate = useNavigate();
//   const [showAddModelModal, setShowAddModelModal] = useState(false);
//   const [services, setServices] = useState([]);
//   const [selectedServices, setSelectedServices] = useState([]);
//   const [serviceSearch, setServiceSearch] = useState("");
//   const [brands, setBrands] = useState([]);
//   const [staff, setStaff] = useState([]);
//   const [models, setModels] = useState([]);
//   const [showServiceDropdown, setShowServiceDropdown] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [selectedServiceType, setSelectedServiceType] = useState("");
//   const [selectedBrand, setSelectedBrand] = useState("");
//   const [billStaff, setBillStaff] = useState("");
//   const [billNo, setBillNo] = useState("");
//   const [isAddingService, setIsAddingService] = useState(false);
//   const [isFetched, setIsFetched] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [previousPaid, setPreviousPaid] = useState(0);
//   const [currentPaid, setCurrentPaid] = useState(0);

//   const [formData, setFormData] = useState({
//     sale_date: new Date().toISOString().split("T")[0],
//     bill_no: "",
//     ref_no: "",
//     name: "",
//     mobile_no: "",
//     brand: "",
//     model: "",
//     imei: "",
//     reasons: "",
//     technician: "",
//     advance_amount: "",
//     cash: "",
//     payment_type: "",
//     gstin: "",
//     sub_total: 0,
//     gst_amount: 0,
//     net_total: 0,
//     paid: 0,
//     balance: 0,
//     bill_staff: "",
//   });

//   const [selectedService, setSelectedService] = useState({
//     service_id: "",
//     service_name: "",
//     serviceType: "",
//     basePrice: "",
//     basePriceExclTax: 0,
//     hsnCode: "",
//     description: "",
//     tax_percentage: "18",
//     cgst: 0,
//     sgst: 0,
//     quantity: 1,
//     total: 0,
//   });

//   const [isManual, setIsManual] = useState(false);
//   const [newModelData, setNewModelData] = useState({
//     modelName: "",
//     brand: "",
//     year: "",
//     specifications: "",
//     modelStatus: "Active",
//   });
//   const [editIndex, setEditIndex] = useState(null);

//   const roundTo2 = (num) => Math.round((num || 0) * 100) / 100;

//   // ===== NEW LOGIC: Calculate balance when both advance and cash are provided =====
//   const calculateBalance = () => {
//     const advanceAmount = roundTo2(parseFloat(formData.advance_amount) || "");
//     const cashAmount = roundTo2(parseFloat(formData.cash) || "");
//     const netTotal = roundTo2(formData.net_total);

//     // Check if both advance and cash have values
//     if (advanceAmount > 0 && cashAmount > 0) {
//       const totalPaid = roundTo2(advanceAmount + cashAmount);
//       const balance = roundTo2(netTotal - totalPaid);

//       // Update formData with new calculations
//       setFormData((prev) => ({
//         ...prev,
//         paid: totalPaid < 0 ? 0 : totalPaid,
//         balance: balance < 0 ? 0 : balance,
//       }));

//       return {
//         totalPaid: totalPaid < 0 ? 0 : totalPaid,
//         balance: balance < 0 ? 0 : balance,
//       };
//     }

//     return null;
//   };
//   // ===== END NEW LOGIC =====

//   useEffect(() => {
//     const getStaff = localStorage.getItem("username");
//     if (getStaff) {
//       setBillStaff(getStaff);
//       setFormData((prev) => ({ ...prev, bill_staff: getStaff }));
//     }
//   }, []);

//   useEffect(() => {
//     const fetchStaff = async () => {
//       try {
//         const response = await axios.get(`${Apiurl}/staff`);
//         setStaff(Array.isArray(response.data) ? response.data : []);
//       } catch (error) {
//         console.error("Error fetching staff:", error);
//         setError("Failed to fetch staff. Please try again.");
//       }
//     };
//     fetchStaff();
//   }, []);

//   useEffect(() => {
//     const fetchBillNo = async () => {
//       try {
//         const response = await axios.get(`${Apiurl}/generate_billno`);
//         const billNumber = response.data.bill_no;
//         setBillNo(billNumber);
//         setFormData((prev) => ({ ...prev, bill_no: billNumber }));
//       } catch (error) {
//         console.error("Error fetching bill number:", error);
//         setError("Failed to fetch bill number. Please try again.");
//       }
//     };
//     fetchBillNo();
//   }, []);

//   useEffect(() => {
//     const fetchBrands = async () => {
//       try {
//         const response = await axios.get(`${Apiurl}/brand`);
//         setBrands(response.data);
//       } catch (error) {
//         console.error("Error fetching brands:", error);
//         setError("Failed to fetch brands. Please try again.");
//       }
//     };

//     const fetchServices = async () => {
//       try {
//         setIsLoading(true);
//         const response = await axios.get(`${Apiurl}/service`);
//         setServices(
//           response.data.map((service) => ({
//             ...service,
//             basePrice: roundTo2(parseFloat(service.basePrice) || 0),
//             GST_tax: roundTo2(parseFloat(service.GST_tax) || 0),
//           })),
//         );
//       } catch (error) {
//         console.error("Error fetching services:", error);
//         setError("Failed to fetch services. Please try again.");
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchBrands();
//     fetchServices();
//   }, []);

//   useEffect(() => {
//     const fetchModels = async () => {
//       if (formData.brand) {
//         try {
//           const response = await axios.get(
//             `${Apiurl}/model?brand_name=${encodeURIComponent(formData.brand)}`,
//           );
//           const filteredModels = response.data.filter(
//             (model) => model.brand_name === formData.brand,
//           );
//           setModels(filteredModels);
//           if (!filteredModels.some((m) => m.model_name === formData.model)) {
//             setFormData((prev) => ({ ...prev, model: "" }));
//           }
//         } catch (error) {
//           console.error("Error fetching models:", error);
//           setError("Failed to fetch models. Please try again.");
//           setModels([]);
//           setFormData((prev) => ({ ...prev, model: "" }));
//         }
//       } else {
//         setModels([]);
//         setFormData((prev) => ({ ...prev, model: "" }));
//       }
//     };
//     fetchModels();
//   }, [formData.brand]);

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, []);

//   // ====== Old Logic (Updated with new logic integration) =====
//   // useEffect(() => {
//   //   setFormData((prev) => {
//   //     const subTotal = roundTo2(
//   //       selectedServices.reduce(
//   //         (sum, item) => sum + roundTo2(item.basePriceExclTax * item.quantity),
//   //         0
//   //       )
//   //     );
//   //     const gstAmount = roundTo2(
//   //       selectedServices.reduce(
//   //         (sum, item) => sum + roundTo2(item.cgst + item.sgst),
//   //         0
//   //       )
//   //     );
//   //     const netTotal = roundTo2(subTotal + gstAmount);
//   //     let totalPaid = roundTo2(previousPaid + currentPaid);
//   //     let balance = 0;

//   //     // Apply NEW LOGIC when both advance and cash are present
//   //     const advanceAmount = roundTo2(parseFloat(prev.advance_amount) || 0);
//   //     const cashAmount = roundTo2(parseFloat(prev.cash) || 0);

//   //     if (advanceAmount > 0 && cashAmount > 0) {
//   //       // NEW LOGIC: Add both advance and cash
//   //       totalPaid = roundTo2(advanceAmount + cashAmount);
//   //       balance = roundTo2(netTotal - totalPaid);
//   //     } else if (prev.cash > 0) {
//   //       // Cash logic from existing code
//   //       totalPaid = netTotal;
//   //       balance = 0;
//   //     } else {
//   //       // No cash, calculate normally
//   //       balance = roundTo2(netTotal - totalPaid);
//   //     }

//   //     return {
//   //       ...prev,
//   //       sub_total: subTotal,
//   //       gst_amount: gstAmount,
//   //       net_total: netTotal,
//   //       paid: totalPaid,
//   //       balance: balance < 0 ? 0 : balance,
//   //     };
//   //   });
//   // }, [
//   //   selectedServices,
//   //   previousPaid,
//   //   currentPaid,
//   //   formData.cash,
//   //   formData.advance_amount,
//   // ]);

//   useEffect(() => {
//     setFormData((prev) => {
//       const subTotal = roundTo2(
//         selectedServices.reduce(
//           (sum, item) => sum + roundTo2(item.basePriceExclTax * item.quantity),
//           0,
//         ),
//       );
//       const gstAmount = roundTo2(
//         selectedServices.reduce(
//           (sum, item) => sum + roundTo2(item.cgst + item.sgst),
//           0,
//         ),
//       );
//       const netTotal = roundTo2(subTotal + gstAmount);
//       let totalPaid = roundTo2(previousPaid + currentPaid);
//       let balance = 0;

//       // Apply NEW LOGIC when both advance and cash are present
//       const advanceAmount = roundTo2(parseFloat(prev.advance_amount) || "");
//       const cashAmount = roundTo2(parseFloat(prev.cash) || "");

//       if (advanceAmount > 0 && cashAmount > 0) {
//         // NEW LOGIC: Add both advance and cash
//         totalPaid = roundTo2(advanceAmount + cashAmount);
//         balance = roundTo2(netTotal - totalPaid);
//       } else if (prev.cash > 0) {
//         // Cash logic from existing code
//         totalPaid = netTotal;
//         balance = 0;
//       } else {
//         // No cash, calculate normally
//         balance = roundTo2(netTotal - totalPaid);
//       }

//       return {
//         ...prev,
//         sub_total: subTotal,
//         gst_amount: gstAmount,
//         net_total: netTotal,
//         paid: totalPaid,
//         balance: balance < 0 ? 0 : balance,
//       };
//     });
//   }, [
//     selectedServices,
//     previousPaid,
//     currentPaid,
//     formData.cash,
//     formData.advance_amount,
//   ]);

//   const handleInputChangeStaff = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//       ...(name === "advance_amount"
//         ? { [name]: roundTo2(parseFloat(value) || 0) }
//         : {}),
//       ...(name === "cash" ? { [name]: roundTo2(parseFloat(value) || 0) } : {}),
//       ...(name === "brand" ? { model: "" } : {}),
//     }));
//   };

//   const handleServiceSearchChange = (e) => {
//     setServiceSearch(e.target.value);
//     setShowServiceDropdown(true);
//   };

//   const filteredServices = services.filter((service) => {
//     const matchesSearch =
//       `${service.serviceName} ${service.category} ${service.serviceType} ${service.hsnCode} ${service.description}`
//         .toLowerCase()
//         .includes(serviceSearch.toLowerCase());
//     const matchesServiceType =
//       selectedServiceType === "Common (All Brands)"
//         ? service.serviceType === "Common (All Brands)"
//         : selectedServiceType === "Brand Specific" && selectedBrand
//           ? service.serviceType === selectedBrand
//           : true;
//     return matchesSearch && matchesServiceType;
//   });

//   const selectService = (service) => {
//     const taxPercentage = roundTo2(parseFloat(service.GST_tax) || 0);
//     const basePrice = roundTo2(parseFloat(service.basePrice) || 0);
//     const basePriceExclTax = roundTo2(basePrice / (1 + taxPercentage / 100));
//     const taxPerUnit = roundTo2(basePrice - basePriceExclTax);
//     const quantity = 1;
//     const totalTax = roundTo2(taxPerUnit * quantity);
//     const total = roundTo2(basePrice * quantity);

//     setSelectedService({
//       service_id: service._id,
//       service_name: service.serviceName,
//       serviceType: service.serviceType,
//       basePrice,
//       basePriceExclTax,
//       hsnCode: service.hsnCode || "",
//       description: service.description || "",
//       tax_percentage: taxPercentage,
//       cgst: roundTo2(totalTax / 2),
//       sgst: roundTo2(totalTax / 2),
//       quantity,
//       total,
//     });
//     setServiceSearch(service.serviceName);
//     setShowServiceDropdown(false);
//     setEditIndex(null);
//   };

//   const handleServiceInputChange = (e) => {
//     const { name, value } = e.target;
//     setSelectedService((prev) => {
//       const updatedService = {
//         ...prev,
//         [name]:
//           name === "quantity" ||
//           name === "basePrice" ||
//           name === "tax_percentage"
//             ? roundTo2(parseFloat(value) || 0)
//             : value,
//       };

//       const basePrice =
//         name === "basePrice"
//           ? roundTo2(parseFloat(value) || 0)
//           : updatedService.basePrice;
//       const taxPercentage =
//         name === "tax_percentage"
//           ? roundTo2(parseFloat(value) || 0)
//           : updatedService.tax_percentage;
//       const quantity =
//         name === "quantity"
//           ? roundTo2(parseFloat(value) || 1)
//           : updatedService.quantity;

//       const basePriceExclTax = roundTo2(basePrice / (1 + taxPercentage / 100));
//       const taxPerUnit = roundTo2(basePrice - basePriceExclTax);
//       const totalTax = roundTo2(taxPerUnit * quantity);

//       return {
//         ...updatedService,
//         basePriceExclTax,
//         cgst: roundTo2(totalTax / 2),
//         sgst: roundTo2(totalTax / 2),
//         total: roundTo2(quantity * basePrice),
//       };
//     });

//     if (name === "service_name") {
//       setServiceSearch(value);
//     }
//   };

//   const addServiceToTable = async () => {
//     if (isAddingService) return;
//     setIsAddingService(true);

//     let tempService = { ...selectedService };
//     if (!tempService.service_name) {
//       tempService.service_name = serviceSearch;
//     }

//     if (!tempService.service_id) {
//       tempService.service_id = `manual_${
//         tempService.service_name || "unnamed"
//       }_${tempService.serviceType || "unspecified"}`;
//     }

//     if (!tempService.service_name || tempService.quantity <= 0) {
//       alert("Please enter a service name and a valid quantity greater than 0.");
//       setIsAddingService(false);
//       return;
//     }

//     if (isManual && editIndex === null) {
//       try {
//         const serviceData = {
//           serviceName: tempService.service_name,
//           serviceType: tempService.serviceType || "Common (All Brands)",
//           basePrice: roundTo2(tempService.basePrice),
//           GST_tax: roundTo2(tempService.tax_percentage),
//           hsnCode: tempService.hsnCode || "",
//           description: tempService.description || "",
//           category: "",
//         };

//         const response = await axios.post(`${Apiurl}/service`, serviceData);
//         tempService.service_id = response.data._id;
//         setServices((prev) => [
//           ...prev,
//           {
//             ...response.data,
//             basePrice: roundTo2(response.data.basePrice),
//             GST_tax: roundTo2(response.data.GST_tax),
//           },
//         ]);
//       } catch (error) {
//         console.error("Error adding new service:", error);
//         alert(
//           `Failed to add new service: ${
//             error.response?.data?.message || error.message
//           }`,
//         );
//         setIsAddingService(false);
//         return;
//       }
//     }

//     const basePriceExclTax = roundTo2(
//       tempService.basePrice / (1 + tempService.tax_percentage / 100),
//     );
//     const taxPerUnit = roundTo2(tempService.basePrice - basePriceExclTax);
//     const totalTax = roundTo2(taxPerUnit * tempService.quantity);

//     const updatedService = {
//       ...tempService,
//       basePriceExclTax,
//       cgst: roundTo2(totalTax / 2),
//       sgst: roundTo2(totalTax / 2),
//       total: roundTo2(tempService.quantity * tempService.basePrice),
//     };

//     setSelectedServices((prev) => {
//       if (editIndex !== null) {
//         const updatedServices = [...prev];
//         updatedServices[editIndex] = updatedService;
//         return updatedServices;
//       } else {
//         const existingServiceIndex = prev.findIndex(
//           (item) => item.service_id === tempService.service_id,
//         );

//         if (existingServiceIndex !== -1) {
//           const updatedServices = [...prev];
//           updatedServices[existingServiceIndex].quantity +=
//             tempService.quantity;
//           updatedServices[existingServiceIndex].total = roundTo2(
//             updatedServices[existingServiceIndex].quantity *
//               updatedServices[existingServiceIndex].basePrice,
//           );
//           updatedServices[existingServiceIndex].basePriceExclTax = roundTo2(
//             updatedServices[existingServiceIndex].basePrice /
//               (1 + updatedServices[existingServiceIndex].tax_percentage / 100),
//           );

//           const taxPerUnit = roundTo2(
//             updatedServices[existingServiceIndex].basePrice -
//               updatedServices[existingServiceIndex].basePriceExclTax,
//           );
//           const totalTax = roundTo2(
//             taxPerUnit * updatedServices[existingServiceIndex].quantity,
//           );
//           updatedServices[existingServiceIndex].cgst = roundTo2(totalTax / 2);
//           updatedServices[existingServiceIndex].sgst = roundTo2(totalTax / 2);
//           return updatedServices;
//         } else {
//           return [...prev, updatedService];
//         }
//       }
//     });

//     setSelectedService({
//       service_id: "",
//       service_name: "",
//       serviceType: "",
//       basePrice: "",
//       basePriceExclTax: 0,
//       hsnCode: "",
//       description: "",
//       tax_percentage: "18",
//       cgst: 0,
//       sgst: 0,
//       quantity: 1,
//       total: 0,
//     });
//     setServiceSearch("");
//     setShowServiceDropdown(false);
//     setIsManual(false);
//     setEditIndex(null);
//     setIsAddingService(false);
//   };

//   const updateQuantity = (index, newQuantity) => {
//     setSelectedServices((prev) => {
//       const updatedServices = [...prev];
//       const item = updatedServices[index];
//       item.quantity = Math.max(parseInt(newQuantity) || 1, 1);
//       item.basePriceExclTax = roundTo2(
//         item.basePrice / (1 + (item.tax_percentage || 0) / 100),
//       );
//       const taxPerUnit = roundTo2(item.basePrice - item.basePriceExclTax);
//       const totalTax = roundTo2(taxPerUnit * item.quantity);
//       item.cgst = roundTo2(totalTax / 2);
//       item.sgst = roundTo2(totalTax / 2);
//       item.total = roundTo2(item.quantity * item.basePrice);
//       return updatedServices;
//     });
//   };

//   const updatePrice = (index, newPriceStr) => {
//     const newPrice = roundTo2(parseFloat(newPriceStr) || 0);
//     if (newPrice <= 0) return;

//     setSelectedServices((prev) => {
//       const updatedServices = [...prev];
//       const item = updatedServices[index];
//       item.basePrice = newPrice;
//       item.basePriceExclTax = roundTo2(
//         item.basePrice / (1 + (item.tax_percentage || 0) / 100),
//       );
//       const taxPerUnit = roundTo2(newPrice - item.basePriceExclTax);
//       const totalTax = roundTo2(taxPerUnit * item.quantity);
//       item.cgst = roundTo2(totalTax / 2);
//       item.sgst = roundTo2(totalTax / 2);
//       item.total = roundTo2(item.quantity * newPrice);
//       return updatedServices;
//     });
//   };

//   const updateGst = (index, newGstStr) => {
//     const newGst = roundTo2(parseFloat(newGstStr) || 0);
//     setSelectedServices((prev) => {
//       const updatedServices = [...prev];
//       const item = updatedServices[index];
//       item.tax_percentage = newGst;
//       item.basePriceExclTax = roundTo2(item.basePrice / (1 + newGst / 100));
//       const taxPerUnit = roundTo2(item.basePrice - item.basePriceExclTax);
//       const totalTax = roundTo2(taxPerUnit * item.quantity);
//       item.cgst = roundTo2(totalTax / 2);
//       item.sgst = roundTo2(totalTax / 2);
//       item.total = roundTo2(item.quantity * item.basePrice);
//       return updatedServices;
//     });
//   };

//   const editService = (index) => {
//     const item = selectedServices[index];
//     setSelectedService(item);
//     setServiceSearch(item.service_name);
//     setShowServiceDropdown(false);
//     setIsManual(true);
//     setEditIndex(index);
//   };

//   const removeService = (index) => {
//     setSelectedServices((prev) => prev.filter((_, i) => i !== index));
//     if (editIndex === index) {
//       setEditIndex(null);
//       setSelectedService({
//         service_id: "",
//         service_name: "",
//         serviceType: "",
//         basePrice: "",
//         basePriceExclTax: 0,
//         hsnCode: "",
//         description: "",
//         tax_percentage: "18",
//         cgst: 0,
//         sgst: 0,
//         quantity: 1,
//         total: 0,
//       });
//       setServiceSearch("");
//       setIsManual(false);
//     }
//   };

//   const handleNewModelInputChange = (e) => {
//     const { name, value } = e.target;
//     setNewModelData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleAddModel = async (e) => {
//     e.preventDefault();
//     if (!newModelData.modelName.trim()) {
//       alert("Model name is required.");
//       return;
//     }
//     if (!newModelData.brand) {
//       alert("Brand is required.");
//       return;
//     }

//     try {
//       const modelData = {
//         model_name: newModelData.modelName.trim(),
//         brand_name: newModelData.brand,
//         status: newModelData.modelStatus,
//       };

//       await axios.post(`${Apiurl}/model`, modelData);
//       setFormData((prev) => ({ ...prev, model: newModelData.modelName }));
//       setShowAddModelModal(false);
//       setNewModelData({
//         modelName: "",
//         brand: formData.brand,
//         year: "",
//         specifications: "",
//         modelStatus: "Active",
//       });

//       if (formData.brand === newModelData.brand) {
//         const response = await axios.get(
//           `${Apiurl}/model?brand_name=${encodeURIComponent(formData.brand)}`,
//         );
//         setModels(
//           response.data.filter((model) => model.brand_name === formData.brand),
//         );
//       }
//     } catch (error) {
//       console.error("Error adding model:", error);
//       alert(
//         `Failed to add model: ${error.response?.data?.message || error.message}`,
//       );
//     }
//   };

//   const handleCloseAddModelModal = () => {
//     setShowAddModelModal(false);
//     setNewModelData({
//       modelName: "",
//       brand: formData.brand,
//       year: "",
//       specifications: "",
//       modelStatus: "Active",
//     });
//   };

//   const fetchBillData = async () => {
//     if (!formData.ref_no) {
//       alert("Please enter a Previous Bill No to fetch data.");
//       return;
//     }

//     try {
//       setIsLoading(true);
//       setError("");
//       const response = await axios.get(
//         `${Apiurl}/generalbill_ref/${formData.ref_no}`,
//       );

//       if (response.status === 200 && response.data) {
//         const bill = response.data;
//         const modelValue =
//           typeof bill.model === "object"
//             ? bill.model.model_name
//             : bill.model || "";

//         // Generate NEW bill number for this new bill
//         const billNoResponse = await axios.get(`${Apiurl}/generate_billno`);
//         const newBillNumber = billNoResponse.data.bill_no;
//         setBillNo(newBillNumber);

//         // Only fill customer & device info
//         setFormData((prev) => ({
//           ...prev,
//           sale_date: new Date(bill.date || new Date())
//             .toISOString()
//             .split("T")[0],
//           bill_no: newBillNumber,
//           ref_no: formData.ref_no, // keep entered ref_no
//           name: bill.name || "",
//           mobile_no: bill.mobile_no || "",
//           reasons: bill.reasons || "", // Address
//           brand: bill.brand || "",
//           model: modelValue,
//           imei: bill.imei || "",
//           technician: bill.technician || "",
//           payment_type: bill.Paytype || "",
//           // DO NOT touch payment fields
//           advance_amount: "",
//           cash: "",
//           sub_total: 0,
//           gst_amount: 0,
//           net_total: 0,
//           paid: 0,
//           balance: 0,
//         }));

//         // Load models if brand exists
//         if (bill.brand) {
//           const modelRes = await axios.get(
//             `${Apiurl}/model?brand_name=${encodeURIComponent(bill.brand)}`,
//           );
//           setModels(modelRes.data.filter((m) => m.brand_name === bill.brand));
//         }

//         // Clear services & payments
//         setSelectedServices([]);
//         setPreviousPaid(0);
//         setCurrentPaid(0);
//         setIsFetched(true); // optional flag
//         alert(
//           "Customer details loaded successfully! You can now add new services.",
//         );
//       } else {
//         alert("No bill found with that reference number.");
//       }
//     } catch (error) {
//       console.error("Error fetching bill:", error);
//       alert("Bill not found or error occurred.");
//       setError("Failed to fetch bill data.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // save and print -- final (Updated with new logic)
//   const handleSubmit = async () => {
//     if (!formData.payment_type) {
//       alert("Please select a Payment Type");
//       return;
//     }

//     const advanceAmount = roundTo2(parseFloat(formData.advance_amount) || "");
//     const cashAmount = roundTo2(parseFloat(formData.cash) || "");
//     const netTotal = roundTo2(formData.net_total);
//     let FinalAmt = roundTo2(Number(formData.payment?.[0]?.amount || 0));

//     let currentTotal;
//     if (isFetched) {
//       // For fetched bills → cash only
//       currentTotal = cashAmount > 0 ? cashAmount : formData.balance;
//     } else {
//       // For new bills → use new logic when both advance and cash are present
//       if (advanceAmount > 0 && cashAmount > 0) {
//         // NEW LOGIC: Add both advance and cash
//         currentTotal = roundTo2(advanceAmount + cashAmount);
//         FinalAmt = netTotal - roundTo2(advanceAmount + cashAmount);
//       } else {
//         // Old logic: advance only
//         currentTotal = advanceAmount > 0 ? advanceAmount : netTotal;
//       }
//     }

//     if (
//       currentTotal < 0 ||
//       (isFetched ? cashAmount : advanceAmount) > netTotal
//     ) {
//       alert("Payment amount cannot exceed net total.");
//       return;
//     }

//     // Apply NEW LOGIC for final calculations
//     let updatedPaid, updatedBalance;

//     if (advanceAmount > 0 && cashAmount > 0) {
//       // NEW LOGIC: Add advance + cash
//       updatedPaid = roundTo2(advanceAmount + cashAmount);
//       updatedBalance = roundTo2(netTotal - updatedPaid);
//     } else {
//       // Old logic
//       updatedPaid = roundTo2(previousPaid + currentTotal);
//       updatedBalance = roundTo2(netTotal - updatedPaid);
//     }

//     // Store for display
//     setCurrentPaid(currentTotal);
//     setFormData((prev) => ({
//       ...prev,
//       cash: cashAmount,
//       advance_amount: isFetched ? prev.advance_amount : advanceAmount,
//       paid: updatedPaid,
//       balance: updatedBalance < 0 ? 0 : updatedBalance,
//     }));

//     if (isSubmitting) return;
//     if (!formData.bill_no || !formData.name || selectedServices.length === 0) {
//       alert(
//         "Please fill in bill number, customer name, and select at least one service.",
//       );
//       return;
//     }

//     if (!formData.payment_type) {
//       alert("Please select a Payment Type");
//       return;
//     }

//     setIsSubmitting(true);

//     try {
//       const totalPaid = updatedPaid;
//       const finalBalance = roundTo2(netTotal - totalPaid);
//       const refNumber = formData.ref_no || formData.bill_no;

//       const payments = [];
//       if (currentTotal > 0 || advanceAmount > 0 || cashAmount > 0) {
//         // NEW LOGIC for payment calculation
//         let paymentAmount;
//         let paymentBalance;

//         if (advanceAmount > 0 && cashAmount > 0) {
//           // NEW LOGIC: When both advance and cash are present
//           // amount = advance + cash (what was paid in this transaction)
//           paymentAmount = roundTo2(advanceAmount + cashAmount + finalBalance);
//           // balance = remaining balance after this payment
//           paymentBalance = finalBalance === paymentAmount ? "0" : "0";
//         } else {
//           // Old logic
//           paymentAmount = currentTotal - cashAmount;
//           paymentBalance = finalBalance < 0 ? 0 : finalBalance;
//         }

//         // payments.push({
//         //   bill_no: formData.bill_no,
//         //   date: formData.sale_date,
//         //   total_amount: netTotal,
//         //   payment_type: formData.payment_type,
//         //   paid: finalBalance <= 0,
//         //   amount: paymentAmount,
//         //   balance: paymentBalance,
//         // });

//         if (advanceAmount > 0 && cashAmount > 0) {
//           // ✅ YOUR REQUIRED LOGIC

//           payments.push({
//             bill_no: formData.bill_no,
//             date: formData.sale_date,
//             total_amount: netTotal,
//             payment_type: formData.payment_type, // 👈 selected type
//             paid: true,
//             // amount: roundTo2(netTotal),
//             amount: roundTo2(FinalAmt),
//             balance: 0, // ✅ always ZERO
//           });
//         } else if (advanceAmount > 0) {
//           const finalPayAmount = roundTo2(netTotal - advanceAmount);

//           payments.push({
//             bill_no: formData.bill_no,
//             date: formData.sale_date,
//             total_amount: roundTo2(netTotal),
//             payment_type: formData.payment_type,
//             paid: true,
//             amount: finalPayAmount,
//             balance: 0,
//           });
//         } else if (currentTotal > 0) {
//           // 🔁 old logic for other cases

//           // payments.push({
//           //   bill_no: formData.bill_no,
//           //   date: formData.sale_date,
//           //   total_amount: netTotal,
//           //   payment_type: formData.payment_type,
//           //   paid: finalBalance <= 0,
//           //   amount: currentTotal,
//           //   balance: finalBalance < 0 ? 0 : finalBalance,
//           // });

//           payments.push({
//             bill_no: formData.bill_no,
//             date: formData.sale_date,
//             total_amount: netTotal,
//             payment_type: formData.payment_type,
//             paid: finalBalance <= 0,
//             amount: paymentAmount,
//             balance: paymentBalance,
//           });
//         }
//       }

//       const billData = {
//         bill_no: formData.bill_no,
//         ref_no: refNumber,
//         name: formData.name,
//         mobile_no: formData.mobile_no,
//         brand: formData.brand,
//         model: formData.model,
//         imei: formData.imei,
//         date: formData.sale_date,
//         reasons: formData.reasons,
//         technician: formData.technician,
//         advance_amount: isFetched ? formData.advance_amount : advanceAmount,
//         cash: cashAmount,
//         Paytype: formData.payment_type,
//         gstin: formData.gstin || "0",
//         sub_total: roundTo2(formData.sub_total),
//         net_total: netTotal,
//         gst_amount: roundTo2(formData.gst_amount),
//         bill_staff: billStaff,
//         paid: totalPaid,
//         balance: finalBalance < 0 ? 0 : finalBalance,
//         service_list: selectedServices.map((item) => ({
//           bill_no: formData.bill_no,
//           serviceName: item.service_name,
//           serviceType: item.serviceType,
//           basePrice: roundTo2(item.basePriceExclTax),
//           hsnCode: item.hsnCode,
//           description: item.description,
//           tax_percentage: roundTo2(item.tax_percentage),
//           quantity: item.quantity,
//         })),
//         payment: payments,
//       };

//       console.log("Submitting bill data:", billData);
//       const res = await axios.post(`${Apiurl}/generalbill`, billData);
//       console.log("Bill submitted:", res.data);

//       if (res.status === 200 || res.status === 201) {
//         // reset
//         setSelectedServices([]);
//         setFormData({
//           sale_date: new Date().toISOString().split("T")[0],
//           bill_no: "",
//           ref_no: "",
//           name: "",
//           mobile_no: "",
//           brand: "",
//           model: "",
//           imei: "",
//           reasons: "",
//           technician: "",
//           advance_amount: "",
//           cash: "",
//           payment_type: "",
//           gstin: "",
//           sub_total: 0,
//           gst_amount: 0,
//           net_total: 0,
//           paid: 0,
//           balance: 0,
//           bill_staff: billStaff,
//         });
//         setServiceSearch("");
//         setModels([]);
//         setIsFetched(false);
//         setPreviousPaid(0);
//         setCurrentPaid(0);
//         // print
//         // window.open(`/invoice-bill/${formData.bill_no}`, "_self");
//         window.open(`/invoice-bill/${res.data.bill_no}`, "_self");
//       }
//     } catch (err) {
//       console.error("Error:", err);
//       alert(
//         `Failed to submit bill: ${err.response?.data?.message || err.message}`,
//       );
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleClearOverAll = async () => {
//     try {
//       const response = await axios.get(`${Apiurl}/generate_billno`);
//       setFormData({
//         sale_date: new Date().toISOString().split("T")[0],
//         bill_no: response.data.bill_no || `BILL-${Date.now()}`,
//         ref_no: "",
//         name: "",
//         mobile_no: "",
//         brand: "",
//         model: "",
//         imei: "",
//         reasons: "",
//         technician: "",
//         advance_amount: "",
//         cash: "",
//         payment_type: "",
//         gstin: "",
//         sub_total: 0,
//         gst_amount: 0,
//         net_total: 0,
//         paid: 0,
//         balance: 0,
//         bill_staff: billStaff,
//       });
//       setSelectedServices([]);
//       setServiceSearch("");
//       setSelectedService({
//         service_id: "",
//         service_name: "",
//         serviceType: "",
//         basePrice: "",
//         basePriceExclTax: 0,
//         hsnCode: "",
//         description: "",
//         tax_percentage: "18",
//         cgst: 0,
//         sgst: 0,
//         quantity: 1,
//         total: 0,
//       });
//       setSelectedBrand("");
//       setModels([]);
//       setIsFetched(false);
//       setPreviousPaid(0);
//       setCurrentPaid(0);
//       setEditIndex(null);
//     } catch (error) {
//       alert("Failed to fetch new bill number.");
//     }
//   };

//   const handleCancel = () => {
//     navigate("/bill/general");
//   };

//   return (
//     <>
//       <style>
//         {`
//           .form-control, .form-select {
//             border: 1px solid #00000086 !important;
//           }
//           .input-group .form-control {
//             border-right: none !important;
//           }
//           .input-group .btn {
//             border: 1px solid #00000086 !important;
//           }
//           .table-scroll-350 {
//             max-height: 350px;
//             overflow-y: auto;
//           }
//         `}
//       </style>
//       <div className="p-3" style={{ overflow: "hidden" }}>
//         {error && <div className="alert alert-danger">{error}</div>}
//         {isLoading && <div className="alert alert-info">Loading...</div>}
//         <div className="row">
//           <div className="col-lg-9 col-xl-9">
//             <div className="card p-2">
//               <div className="row">
//                 <div className="col-md-12">
//                   <div className="row">
//                     <div className="col-md-3">
//                       <label className="mb-1 fw-bold">Customer Name</label>
//                       <input
//                         className="form-control"
//                         type="text"
//                         name="name"
//                         value={formData.name}
//                         onChange={handleInputChange}
//                         placeholder="Enter Customer Name"
//                       />
//                     </div>
//                     <div className="col-md-2">
//                       <label className="fw-bold">Pay Type</label>
//                       <select
//                         className="form-select form-control-sm"
//                         name="payment_type"
//                         value={formData.payment_type}
//                         onChange={handleInputChange}
//                       >
//                         <option value="">-- Select PayType --</option>
//                         <option value="Phonepe">Phonepe</option>
//                         <option value="Cash">Cash</option>
//                         <option value="Card">Card</option>
//                         <option value="Bank Transfer">Bank Transfer</option>
//                       </select>
//                     </div>
//                     <div className="col-md-3">
//                       <label className="mb-1 fw-bold">Mobile No</label>
//                       <input
//                         className="form-control"
//                         type="text"
//                         name="mobile_no"
//                         value={formData.mobile_no}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           if (/^\d{0,10}$/.test(value)) {
//                             setFormData((prev) => ({
//                               ...prev,
//                               mobile_no: value,
//                             }));
//                           }
//                         }}
//                         placeholder="Enter Mobile Number"
//                         maxLength={10}
//                       />
//                     </div>
//                     <div className="col-md-4">
//                       <label className="mb-1 fw-bold">Address</label>
//                       <input
//                         className="form-control"
//                         name="reasons"
//                         value={formData.reasons}
//                         onChange={handleInputChange}
//                         placeholder="Enter Address"
//                       />
//                     </div>
//                     <div className="col-md-3 mb-2">
//                       <label className="mb-1 fw-bold">Brand</label>
//                       <select
//                         className="form-select"
//                         name="brand"
//                         value={formData.brand}
//                         onChange={handleInputChange}
//                       >
//                         <option value="">-- Select Brand --</option>
//                         {brands.map((brand) => (
//                           <option key={brand._id} value={brand.brand_name}>
//                             {brand.brand_name}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                     <div className="col-md-3 mb-2">
//                       <label className="mb-1 fw-bold">Model</label>
//                       <div className="input-group">
//                         <select
//                           id="model"
//                           className="form-select"
//                           name="model"
//                           placeholder="Model"
//                           value={formData.model}
//                           onChange={handleInputChange}
//                           disabled={!formData.brand}
//                         >
//                           <option value="">-- Select Model --</option>
//                           {models.map((model) => (
//                             <option key={model._id} value={model.model_name}>
//                               {model.model_name}
//                             </option>
//                           ))}
//                         </select>
//                         <button
//                           className="btn btn-primary"
//                           type="button"
//                           onClick={() => {
//                             setNewModelData((prev) => ({
//                               ...prev,
//                               brand: formData.brand,
//                             }));
//                             setShowAddModelModal(true);
//                           }}
//                           disabled={!formData.brand}
//                         >
//                           +
//                         </button>
//                       </div>
//                     </div>
//                     <div className="col-md-3 mb-2">
//                       <label className="mb-1 fw-bold">IMEI</label>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         name="imei"
//                         value={formData.imei}
//                         onChange={(e) => {
//                           const value = e.target.value
//                             .replace(/\D/g, "")
//                             .slice(0, 15);
//                           handleInputChange({
//                             target: { name: "imei", value },
//                           });
//                         }}
//                         placeholder="Enter IMEI Number"
//                         maxLength={15}
//                       />
//                     </div>
//                     <div className="col-md-3 mb-2">
//                       <label className="mb-1 fw-bold">Technician</label>
//                       <select
//                         className="form-select"
//                         name="technician"
//                         value={formData.technician}
//                         onChange={handleInputChangeStaff}
//                       >
//                         <option value="">-- Select Technician --</option>
//                         {staff
//                           .filter((person) => person.role === "Technician")
//                           .map((person) => (
//                             <option key={person._id} value={person.full_name}>
//                               {person.full_name}
//                             </option>
//                           ))}
//                       </select>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="row p-2">
//               <div className="border rounded p-3 bg-white">
//                 {!isManual ? (
//                   <div className="row mb-2">
//                     <div className="col-md-4 col-lg-4 col-xl-4 position-relative">
//                       <label className="form-label fw-bold">Service Name</label>
//                       <div className="input-group">
//                         <input
//                           type="text"
//                           className="form-control form-control-sm"
//                           value={serviceSearch}
//                           onChange={handleServiceSearchChange}
//                           onFocus={() => setShowServiceDropdown(true)}
//                           placeholder="Enter Service Name"
//                         />
//                         <button
//                           className="btn btn-primary d-flex justify-content-center align-items-center"
//                           style={{ height: "32px" }}
//                           type="button"
//                           onClick={() => {
//                             setIsManual(true);
//                             setShowServiceDropdown(false);
//                             setSelectedService({
//                               service_id: "",
//                               service_name: "",
//                               serviceType: "",
//                               basePrice: "",
//                               basePriceExclTax: 0,
//                               hsnCode: "",
//                               description: "",
//                               tax_percentage: "18",
//                               cgst: 0,
//                               sgst: 0,
//                               quantity: 1,
//                               total: 0,
//                             });
//                             setServiceSearch("");
//                             setEditIndex(null);
//                           }}
//                         >
//                           +
//                         </button>
//                       </div>
//                       {showServiceDropdown && filteredServices.length > 0 && (
//                         <ul
//                           className="list-group position-absolute w-100"
//                           style={{
//                             zIndex: 1000,
//                             maxHeight: "200px",
//                             overflowY: "auto",
//                             top: "100%",
//                             left: 0,
//                           }}
//                         >
//                           {filteredServices.map((service) => (
//                             <li
//                               key={service._id}
//                               className="list-group-item list-group-item-action"
//                               style={{ cursor: "pointer" }}
//                               onClick={() => selectService(service)}
//                             >
//                               {service.serviceName} <br />({service.hsnCode}/{" "}
//                               {service.basePrice.toFixed(2)}/{" "}
//                               {service.GST_tax.toFixed(2)}%)
//                             </li>
//                           ))}
//                         </ul>
//                       )}
//                     </div>
//                     <div className="col-md-1 col-lg-1 col-xl-1">
//                       <label className="form-label fw-bold">Qty</label>
//                       <input
//                         type="number"
//                         className="form-control form-control-sm"
//                         name="quantity"
//                         value={selectedService.quantity}
//                         onChange={handleServiceInputChange}
//                         placeholder="Quantity"
//                         min="1"
//                       />
//                     </div>
//                     <div className="col-md-2 col-lg-2">
//                       <label className="form-label fw-bold">HSN Code</label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         name="hsnCode"
//                         value={selectedService.hsnCode}
//                         onChange={handleServiceInputChange}
//                         placeholder="HSN Code"
//                       />
//                     </div>
//                     <div className="col-md-2 col-lg-2 col-xl-2">
//                       <label className="form-label fw-bold">
//                         Price (Inc. GST)
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         name="basePrice"
//                         value={selectedService.basePrice}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           if (/^\d*\.?\d*$/.test(value)) {
//                             handleServiceInputChange(e);
//                           }
//                         }}
//                         placeholder="Price"
//                       />
//                     </div>
//                     <div className="col-md-1 col-lg-1 col-xl-1">
//                       <label className="form-label fw-bold">GST %</label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         name="tax_percentage"
//                         value={selectedService.tax_percentage}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           if (/^\d*\.?\d*$/.test(value)) {
//                             handleServiceInputChange(e);
//                           }
//                         }}
//                         placeholder="GST %"
//                       />
//                     </div>
//                     <div className="col-md-1 col-lg-1 col-xl-1 mt-4">
//                       <button
//                         type="button"
//                         className="btn btn-sm btn-success mt-2 w-100"
//                         onClick={addServiceToTable}
//                         disabled={isAddingService}
//                       >
//                         +
//                       </button>
//                     </div>
//                   </div>
//                 ) : (
//                   <div className="row mb-2">
//                     <div className="col-md-3">
//                       <label className="form-label fw-bold">Service Name</label>
//                       <div className="d-flex">
//                         <input
//                           type="text"
//                           className="form-control form-control-sm flex-grow-1"
//                           name="service_name"
//                           value={selectedService.service_name}
//                           onChange={handleServiceInputChange}
//                           placeholder="Enter Service Name"
//                         />
//                         <button
//                           className="btn btn-sm btn-outline-secondary ms-1 d-flex align-items-center justify-content-center"
//                           style={{
//                             width: "30px",
//                             height: "30px",
//                             padding: 0,
//                             fontWeight: "bold",
//                             fontSize: "14px",
//                             lineHeight: "1",
//                             boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//                             transition: "all 0.2s ease-in-out",
//                           }}
//                           onClick={() => {
//                             setIsManual(false);
//                             setSelectedService({
//                               service_id: "",
//                               service_name: "",
//                               serviceType: "",
//                               basePrice: "",
//                               basePriceExclTax: 0,
//                               hsnCode: "",
//                               description: "",
//                               tax_percentage: "18",
//                               cgst: 0,
//                               sgst: 0,
//                               quantity: 1,
//                               total: 0,
//                             });
//                             setServiceSearch("");
//                             setShowServiceDropdown(false);
//                             setEditIndex(null);
//                           }}
//                           title="Exit Manual Mode"
//                         >
//                           ×
//                         </button>
//                       </div>
//                     </div>
//                     <div className="col-md-2">
//                       <label className="form-label fw-bold">HSN</label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         name="hsnCode"
//                         value={selectedService.hsnCode}
//                         onChange={handleServiceInputChange}
//                         placeholder="HSN Code"
//                       />
//                     </div>
//                     <div className="col-md-2">
//                       <label className="form-label fw-bold">Qty</label>
//                       <input
//                         type="number"
//                         className="form-control form-control-sm"
//                         name="quantity"
//                         value={selectedService.quantity}
//                         onChange={handleServiceInputChange}
//                         placeholder="Qty"
//                         min="1"
//                       />
//                     </div>
//                     <div className="col-md-2">
//                       <label className="form-label fw-bold">
//                         Price (Inc. GST)
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         name="basePrice"
//                         value={selectedService.basePrice}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           if (/^\d*\.?\d*$/.test(value)) {
//                             handleServiceInputChange(e);
//                           }
//                         }}
//                         placeholder="Price"
//                       />
//                     </div>
//                     <div className="col-md-2">
//                       <label className="form-label fw-bold">GST %</label>
//                       <input
//                         type="text"
//                         className="form-control form-control-sm"
//                         name="tax_percentage"
//                         value={selectedService.tax_percentage}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           if (/^\d*\.?\d*$/.test(value)) {
//                             handleServiceInputChange(e);
//                           }
//                         }}
//                         placeholder="Tax %"
//                       />
//                     </div>
//                     <div className="col-md-1 mt-4">
//                       <button
//                         type="button"
//                         className="btn btn-sm btn-success w-100"
//                         onClick={addServiceToTable}
//                         disabled={isAddingService}
//                       >
//                         +
//                       </button>
//                     </div>
//                   </div>
//                 )}
//                 <div className="table-responsive table-scroll-350">
//                   <table className="table table-bordered mb-0">
//                     <thead className="text-center">
//                       <tr>
//                         {[
//                           "S.No",
//                           "Description",
//                           "HSN",
//                           "Qty",
//                           "Rate (Excl. GST)",
//                           "GST %",
//                           "GST Amt",
//                           "Amt (Inc. Tax)",
//                           "Action",
//                         ].map((h, idx) => (
//                           <th
//                             key={idx}
//                             style={{
//                               backgroundColor: "#2e9290",
//                               color: "white",
//                             }}
//                           >
//                             {h}
//                           </th>
//                         ))}
//                       </tr>
//                     </thead>
//                     <tbody className="text-center">
//                       {selectedServices.length > 0 ? (
//                         selectedServices.map((item, index) => (
//                           <tr key={item.service_id}>
//                             <td>{index + 1}</td>
//                             <td>{item.service_name || "N/A"}</td>
//                             <td>{item.hsnCode || "N/A"}</td>
//                             <td>
//                               <input
//                                 type="text"
//                                 inputMode="numeric"
//                                 pattern="[0-9]*"
//                                 className="form-control form-control-sm text-center"
//                                 style={{ width: "60px" }}
//                                 value={item.quantity}
//                                 onChange={(e) => {
//                                   const value = e.target.value.replace(
//                                     /[^0-9]/g,
//                                     "",
//                                   );
//                                   updateQuantity(index, parseInt(value) || 0);
//                                 }}
//                                 placeholder="0"
//                               />
//                             </td>
//                             <td>
//                               <input
//                                 type="text"
//                                 inputMode="decimal"
//                                 pattern="[0-9.]*"
//                                 className="form-control form-control-sm text-center"
//                                 style={{ width: "80px" }}
//                                 value={item.basePriceExclTax.toFixed(2)}
//                                 onChange={(e) => {
//                                   const value = e.target.value.replace(
//                                     /[^0-9.]/g,
//                                     "",
//                                   );
//                                   const newPriceExclTax = roundTo2(
//                                     parseFloat(value) || 0,
//                                   );
//                                   const newPrice = roundTo2(
//                                     newPriceExclTax *
//                                       (1 + (item.tax_percentage || 0) / 100),
//                                   );
//                                   updatePrice(index, newPrice.toString());
//                                 }}
//                                 placeholder="0.00"
//                               />
//                             </td>
//                             <td>
//                               <input
//                                 type="text"
//                                 inputMode="decimal"
//                                 pattern="[0-9.]*"
//                                 className="form-control form-control-sm text-center"
//                                 style={{ width: "60px" }}
//                                 value={item.tax_percentage}
//                                 onChange={(e) => {
//                                   const value = e.target.value.replace(
//                                     /[^0-9.]/g,
//                                     "",
//                                   );
//                                   updateGst(index, value);
//                                 }}
//                                 placeholder="0"
//                               />
//                             </td>
//                             <td>
//                               {roundTo2(item.cgst + item.sgst).toFixed(2)}
//                             </td>
//                             <td>{item.total.toFixed(2)}</td>
//                             <td className="d-flex justify-content-center gap-1">
//                               <button
//                                 className="btn btn-sm p-1 border-0"
//                                 style={{ backgroundColor: "transparent" }}
//                                 onClick={() => editService(index)}
//                               >
//                                 <Edit size={16} className="text-primary" />
//                               </button>
//                               <button
//                                 className="btn btn-sm p-1 border-0"
//                                 style={{ backgroundColor: "transparent" }}
//                                 onClick={() => removeService(index)}
//                               >
//                                 <Trash2 size={16} className="text-danger" />
//                               </button>
//                             </td>
//                           </tr>
//                         ))
//                       ) : (
//                         <tr>
//                           <td colSpan="9" className="text-center">
//                             No services selected
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="col-lg-3 col-xl-3">
//             <div className="card">
//               <div className="card-body py-1 px-3">
//                 <div className="row">
//                   <div className="col-lg-6 col-md-6">
//                     <label className="mb-1 fw-bold">Date</label>
//                     <input
//                       type="date"
//                       className="form-control form-control-sm"
//                       name="sale_date"
//                       value={formData.sale_date}
//                       onChange={handleInputChange}
//                     />
//                   </div>
//                   <div className="col-lg-6 col-md-6">
//                     <label className="mb-1 fw-bold">Bill No</label>
//                     <input
//                       className="form-control form-control-sm"
//                       type="text"
//                       name="bill_no"
//                       value={formData.bill_no}
//                       onChange={handleInputChange}
//                       readOnly
//                       placeholder="Bill Number"
//                     />
//                   </div>
//                   {/* <div className="col-lg-11 col-md-11">
//                     <label className="mb-1 fw-bold">Previous Bill No</label>
//                     <div className="input-group">
//                       <input
//                         className="form-control form-control-sm"
//                         type="text"
//                         name="ref_no"
//                         value={formData.ref_no}
//                         onChange={handleInputChange}
//                         placeholder="Previous Bill No"
//                       />
//                       <button
//                         type="button"
//                         className="btn btn-sm btn-primary"
//                         style={{ height: "31px" }}
//                         onClick={fetchBillData}
//                       >
//                         <FaSearch />
//                       </button>
//                     </div>
//                   </div> */}
//                 </div>
//               </div>
//             </div>
//             <div className="card mt-2 p-2">
//               <div className="card-body py-1 px-3">
//                 <div className="row">
//                   <div className="col-5">
//                     <label className="fw-bold">Sub Total</label>
//                   </div>
//                   <div className="col-7">
//                     <input
//                       type="text"
//                       className="form-control form-control-sm"
//                       value={formData.sub_total.toFixed(2)}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="row mt-2">
//                   <div className="col-5">
//                     <label className="fw-bold">GST</label>
//                   </div>
//                   <div className="col-7">
//                     <input
//                       type="text"
//                       className="form-control form-control-sm"
//                       value={formData.gst_amount.toFixed(2)}
//                       readOnly
//                       placeholder="Tax Amount"
//                     />
//                   </div>
//                 </div>
//                 <div
//                   className="row mt-2 p-2"
//                   style={{ backgroundColor: "#2e9290" }}
//                 >
//                   <div className="col-12">
//                     <div className="d-flex justify-content-between align-items-center">
//                       <label className="fs-5 text-white fw-bold mb-0">
//                         Net Total
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control text-end fs-4 fw-bold text-primary mt-3"
//                         style={{ width: "63%" }}
//                         value={Math.round(formData.net_total).toFixed(2)}
//                         readOnly
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="row mt-3">
//                   <div className="col-6">
//                     <label className="fw-bold">Advance</label>
//                     <input
//                       type="text"
//                       className="form-control form-control-sm"
//                       name="advance_amount"
//                       value={formData.advance_amount}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (/^\d*\.?\d*$/.test(value)) {
//                           handleInputChange(e);
//                         }
//                       }}
//                       placeholder="Advance Amount"
//                       disabled={isFetched}
//                     />
//                   </div>
//                   <div className="col-6">
//                     <label className="fw-bold">Cash</label>
//                     <input
//                       type="text"
//                       className="form-control form-control-sm"
//                       name="cash"
//                       value={formData.cash}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (/^\d*\.?\d*$/.test(value)) {
//                           handleInputChange(e);
//                         }
//                       }}
//                       placeholder="Cash"
//                     />
//                   </div>
//                 </div>
//                 <div className="row mt-2">
//                   <div className="col-5">
//                     <label className="fw-bold">Paid</label>
//                   </div>
//                   <div className="col-7">
//                     <input
//                       type="text"
//                       className="form-control form-control-sm"
//                       value={Math.round(formData.paid).toFixed(2)}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="row mt-2">
//                   <div className="col-5">
//                     <label className="fw-bold">Balance</label>
//                   </div>
//                   <div className="col-7">
//                     <input
//                       type="text"
//                       className="form-control form-control-sm"
//                       value={Math.round(formData.balance).toFixed(2)}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="row text-center mb-3">
//                   <div className="col-3">
//                     <button
//                       className="btn btn-sm btn-secondary w-auto"
//                       onClick={handleClearOverAll}
//                     >
//                       Clear
//                     </button>
//                   </div>
//                   <div className="col-6">
//                     <button
//                       className="btn btn-sm btn-success w-auto"
//                       onClick={handleSubmit}
//                       disabled={isSubmitting}
//                     >
//                       Save & Print
//                     </button>
//                   </div>
//                   <div className="col-3">
//                     <button
//                       className="btn btn-sm btn-danger w-auto"
//                       onClick={handleCancel}
//                     >
//                       Back
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div
//         className={`modal fade ${showAddModelModal ? "show d-block" : ""}`}
//         tabIndex="-1"
//         aria-labelledby="addModelModalLabel"
//         aria-hidden={!showAddModelModal}
//         style={{
//           backgroundColor: "rgba(0,0,0,0.5)",
//           transition: "opacity 0.3s ease-in-out",
//           display: showAddModelModal ? "block" : "none",
//         }}
//       >
//         <div className="modal-dialog modal-md modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header border-0">
//               <h5 className="modal-title" id="addModelModalLabel">
//                 Add Model
//               </h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 onClick={handleCloseAddModelModal}
//               ></button>
//             </div>
//             <div className="modal-body">
//               <form onSubmit={handleAddModel}>
//                 <div className="mb-3">
//                   <label className="form-label">Model Name</label>
//                   <input
//                     type="text"
//                     name="modelName"
//                     className="form-control"
//                     value={newModelData.modelName}
//                     onChange={handleNewModelInputChange}
//                     placeholder="e.g., Nord 2"
//                     required
//                   />
//                 </div>
//                 <div className="row">
//                   <div className="col-md-12">
//                     <label className="form-label">Brand</label>
//                     <select
//                       name="brand"
//                       className="form-select"
//                       value={newModelData.brand}
//                       onChange={handleNewModelInputChange}
//                       required
//                     >
//                       <option value="">Select Brand</option>
//                       {brands.map((brand) => (
//                         <option key={brand._id} value={brand.brand_name}>
//                           {brand.brand_name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>
//                 <div className="mb-3">
//                   <label className="form-label">Status</label>
//                   <select
//                     name="modelStatus"
//                     className="form-select"
//                     value={newModelData.modelStatus}
//                     onChange={handleNewModelInputChange}
//                   >
//                     <option value="Active">Active</option>
//                     <option value="Inactive">Inactive</option>
//                   </select>
//                 </div>
//                 <div className="d-flex justify-content-end gap-2">
//                   <button
//                     type="button"
//                     className="btn btn-secondary"
//                     onClick={handleCloseAddModelModal}
//                   >
//                     Close
//                   </button>
//                   <button
//                     type="submit"
//                     className="btn btn-primary"
//                     style={{ backgroundColor: "#2e9290", border: "none" }}
//                   >
//                     Add Model
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Add_GeneralBill;

import React, { useEffect, useState } from "react";
import { Edit, Trash2 } from "lucide-react";
import { FaSearch } from "react-icons/fa";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Apiurl from "../../environment/Apiurl";

const Add_GeneralBill = () => {
  const navigate = useNavigate();
  const [showAddModelModal, setShowAddModelModal] = useState(false);
  const [services, setServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [serviceSearch, setServiceSearch] = useState("");
  const [brands, setBrands] = useState([]);
  const [staff, setStaff] = useState([]);
  const [models, setModels] = useState([]);
  const [showServiceDropdown, setShowServiceDropdown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedServiceType, setSelectedServiceType] = useState("");
  const [selectedBrand, setSelectedBrand] = useState("");
  const [billStaff, setBillStaff] = useState("");
  const [billNo, setBillNo] = useState("");
  const [isAddingService, setIsAddingService] = useState(false);
  const [isFetched, setIsFetched] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [previousPaid, setPreviousPaid] = useState(0);
  const [currentPaid, setCurrentPaid] = useState(0);
  const [showAddService, setShowAddService] = useState(false);

  const [formData, setFormData] = useState({
    sale_date: new Date().toISOString().split("T")[0],
    bill_no: "",
    ref_no: "",
    name: "",
    mobile_no: "",
    brand: "",
    model: "",
    imei: "",
    reasons: "",
    technician: "",
    advance_amount: "",
    cash: "",
    payment_type: "",
    gstin: "",
    sub_total: 0,
    gst_amount: 0,
    net_total: 0,
    paid: 0,
    balance: 0,
    bill_staff: "",
  });

  const [selectedService, setSelectedService] = useState({
    service_id: "",
    service_name: "",
    serviceType: "",
    basePrice: "",
    basePriceExclTax: 0,
    hsnCode: "",
    description: "",
    tax_percentage: "18",
    cgst: 0,
    sgst: 0,
    quantity: 1,
    total: 0,
  });

  const [isManual, setIsManual] = useState(false);
  const [newModelData, setNewModelData] = useState({
    modelName: "",
    brand: "",
    year: "",
    specifications: "",
    modelStatus: "Active",
  });
  const [editIndex, setEditIndex] = useState(null);

  const roundTo2 = (num) => Math.round((num || 0) * 100) / 100;

  // ===== NEW LOGIC: Calculate balance when both advance and cash are provided =====
  const calculateBalance = () => {
    const advanceAmount = roundTo2(parseFloat(formData.advance_amount) || "");
    const cashAmount = roundTo2(parseFloat(formData.cash) || "");
    const netTotal = roundTo2(formData.net_total);

    // Check if both advance and cash have values
    if (advanceAmount > 0 && cashAmount > 0) {
      const totalPaid = roundTo2(advanceAmount + cashAmount);
      const balance = roundTo2(netTotal - totalPaid);

      // Update formData with new calculations
      setFormData((prev) => ({
        ...prev,
        paid: totalPaid < 0 ? 0 : totalPaid,
        balance: balance < 0 ? 0 : balance,
      }));

      return {
        totalPaid: totalPaid < 0 ? 0 : totalPaid,
        balance: balance < 0 ? 0 : balance,
      };
    }

    return null;
  };
  // ===== END NEW LOGIC =====

  useEffect(() => {
    const getStaff = localStorage.getItem("username");
    if (getStaff) {
      setBillStaff(getStaff);
      setFormData((prev) => ({ ...prev, bill_staff: getStaff }));
    }
  }, []);

  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const response = await axios.get(`${Apiurl}/staff`);
        setStaff(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Error fetching staff:", error);
        setError("Failed to fetch staff. Please try again.");
      }
    };
    fetchStaff();
  }, []);

  useEffect(() => {
    const fetchBillNo = async () => {
      try {
        const response = await axios.get(`${Apiurl}/generate_billno`);
        const billNumber = response.data.bill_no;
        setBillNo(billNumber);
        setFormData((prev) => ({ ...prev, bill_no: billNumber }));
      } catch (error) {
        console.error("Error fetching bill number:", error);
        setError("Failed to fetch bill number. Please try again.");
      }
    };
    fetchBillNo();
  }, []);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await axios.get(`${Apiurl}/brand`);
        setBrands(response.data);
      } catch (error) {
        console.error("Error fetching brands:", error);
        setError("Failed to fetch brands. Please try again.");
      }
    };

    const fetchServices = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(`${Apiurl}/service`);
        setServices(
          response.data.map((service) => ({
            ...service,
            basePrice: roundTo2(parseFloat(service.basePrice) || 0),
            GST_tax: roundTo2(parseFloat(service.GST_tax) || 0),
          })),
        );
      } catch (error) {
        console.error("Error fetching services:", error);
        setError("Failed to fetch services. Please try again.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchBrands();
    fetchServices();
  }, []);

  useEffect(() => {
    const fetchModels = async () => {
      if (formData.brand) {
        try {
          const response = await axios.get(
            `${Apiurl}/model?brand_name=${encodeURIComponent(formData.brand)}`,
          );
          const filteredModels = response.data.filter(
            (model) => model.brand_name === formData.brand,
          );
          setModels(filteredModels);
          if (!filteredModels.some((m) => m.model_name === formData.model)) {
            setFormData((prev) => ({ ...prev, model: "" }));
          }
        } catch (error) {
          console.error("Error fetching models:", error);
          setError("Failed to fetch models. Please try again.");
          setModels([]);
          setFormData((prev) => ({ ...prev, model: "" }));
        }
      } else {
        setModels([]);
        setFormData((prev) => ({ ...prev, model: "" }));
      }
    };
    fetchModels();
  }, [formData.brand]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // ====== Old Logic (Updated with new logic integration) =====
  // useEffect(() => {
  //   setFormData((prev) => {
  //     const subTotal = roundTo2(
  //       selectedServices.reduce(
  //         (sum, item) => sum + roundTo2(item.basePriceExclTax * item.quantity),
  //         0
  //       )
  //     );
  //     const gstAmount = roundTo2(
  //       selectedServices.reduce(
  //         (sum, item) => sum + roundTo2(item.cgst + item.sgst),
  //         0
  //       )
  //     );
  //     const netTotal = roundTo2(subTotal + gstAmount);
  //     let totalPaid = roundTo2(previousPaid + currentPaid);
  //     let balance = 0;

  //     // Apply NEW LOGIC when both advance and cash are present
  //     const advanceAmount = roundTo2(parseFloat(prev.advance_amount) || 0);
  //     const cashAmount = roundTo2(parseFloat(prev.cash) || 0);

  //     if (advanceAmount > 0 && cashAmount > 0) {
  //       // NEW LOGIC: Add both advance and cash
  //       totalPaid = roundTo2(advanceAmount + cashAmount);
  //       balance = roundTo2(netTotal - totalPaid);
  //     } else if (prev.cash > 0) {
  //       // Cash logic from existing code
  //       totalPaid = netTotal;
  //       balance = 0;
  //     } else {
  //       // No cash, calculate normally
  //       balance = roundTo2(netTotal - totalPaid);
  //     }

  //     return {
  //       ...prev,
  //       sub_total: subTotal,
  //       gst_amount: gstAmount,
  //       net_total: netTotal,
  //       paid: totalPaid,
  //       balance: balance < 0 ? 0 : balance,
  //     };
  //   });
  // }, [
  //   selectedServices,
  //   previousPaid,
  //   currentPaid,
  //   formData.cash,
  //   formData.advance_amount,
  // ]);

  useEffect(() => {
    setFormData((prev) => {
      const subTotal = roundTo2(
        selectedServices.reduce(
          (sum, item) => sum + roundTo2(item.basePriceExclTax * item.quantity),
          0,
        ),
      );
      const gstAmount = roundTo2(
        selectedServices.reduce(
          (sum, item) => sum + roundTo2(item.cgst + item.sgst),
          0,
        ),
      );
      const netTotal = roundTo2(subTotal + gstAmount);
      let totalPaid = roundTo2(previousPaid + currentPaid);
      let balance = 0;

      // Apply NEW LOGIC when both advance and cash are present
      const advanceAmount = roundTo2(parseFloat(prev.advance_amount) || "");
      const cashAmount = roundTo2(parseFloat(prev.cash) || "");

      if (advanceAmount > 0 && cashAmount > 0) {
        // NEW LOGIC: Add both advance and cash
        totalPaid = roundTo2(advanceAmount + cashAmount);
        balance = roundTo2(netTotal - totalPaid);
      } else if (prev.cash > 0) {
        // Cash logic from existing code
        totalPaid = netTotal;
        balance = 0;
      } else {
        // No cash, calculate normally
        balance = roundTo2(netTotal - totalPaid);
      }

      return {
        ...prev,
        sub_total: subTotal,
        gst_amount: gstAmount,
        net_total: netTotal,
        paid: totalPaid,
        balance: balance < 0 ? 0 : balance,
      };
    });
  }, [
    selectedServices,
    previousPaid,
    currentPaid,
    formData.cash,
    formData.advance_amount,
  ]);

  const handleInputChangeStaff = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
      ...(name === "advance_amount"
        ? { [name]: roundTo2(parseFloat(value) || 0) }
        : {}),
      ...(name === "cash" ? { [name]: roundTo2(parseFloat(value) || 0) } : {}),
      ...(name === "brand" ? { model: "" } : {}),
    }));
  };

  const handleServiceSearchChange = (e) => {
    setServiceSearch(e.target.value);
    setShowServiceDropdown(true);
  };

  const filteredServices = services.filter((service) => {
    const matchesSearch =
      `${service.serviceName} ${service.category} ${service.serviceType} ${service.hsnCode} ${service.description}`
        .toLowerCase()
        .includes(serviceSearch.toLowerCase());
    const matchesServiceType =
      selectedServiceType === "Common (All Brands)"
        ? service.serviceType === "Common (All Brands)"
        : selectedServiceType === "Brand Specific" && selectedBrand
          ? service.serviceType === selectedBrand
          : true;
    return matchesSearch && matchesServiceType;
  });

  const selectService = (service) => {
    const taxPercentage = roundTo2(parseFloat(service.GST_tax) || 0);
    const basePrice = roundTo2(parseFloat(service.basePrice) || 0);
    const basePriceExclTax = roundTo2(basePrice / (1 + taxPercentage / 100));
    const taxPerUnit = roundTo2(basePrice - basePriceExclTax);
    const quantity = 1;
    const totalTax = roundTo2(taxPerUnit * quantity);
    const total = roundTo2(basePrice * quantity);

    setSelectedService({
      service_id: service._id,
      service_name: service.serviceName,
      serviceType: service.serviceType,
      basePrice,
      basePriceExclTax,
      hsnCode: service.hsnCode || "",
      description: service.description || "",
      tax_percentage: taxPercentage,
      cgst: roundTo2(totalTax / 2),
      sgst: roundTo2(totalTax / 2),
      quantity,
      total,
    });
    setServiceSearch(service.serviceName);
    setShowServiceDropdown(false);
    setEditIndex(null);
  };

  const handleServiceInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedService((prev) => {
      const updatedService = {
        ...prev,
        [name]:
          name === "quantity" ||
          name === "basePrice" ||
          name === "tax_percentage"
            ? roundTo2(parseFloat(value) || 0)
            : value,
      };

      const basePrice =
        name === "basePrice"
          ? roundTo2(parseFloat(value) || 0)
          : updatedService.basePrice;
      const taxPercentage =
        name === "tax_percentage"
          ? roundTo2(parseFloat(value) || 0)
          : updatedService.tax_percentage;
      const quantity =
        name === "quantity"
          ? roundTo2(parseFloat(value) || 1)
          : updatedService.quantity;

      const basePriceExclTax = roundTo2(basePrice / (1 + taxPercentage / 100));
      const taxPerUnit = roundTo2(basePrice - basePriceExclTax);
      const totalTax = roundTo2(taxPerUnit * quantity);

      return {
        ...updatedService,
        basePriceExclTax,
        cgst: roundTo2(totalTax / 2),
        sgst: roundTo2(totalTax / 2),
        total: roundTo2(quantity * basePrice),
      };
    });

    if (name === "service_name") {
      setServiceSearch(value);
    }
  };

  const addServiceToTable = async () => {
    if (isAddingService) return;
    setIsAddingService(true);

    let tempService = { ...selectedService };
    if (!tempService.service_name) {
      tempService.service_name = serviceSearch;
    }

    if (!tempService.service_id) {
      tempService.service_id = `manual_${
        tempService.service_name || "unnamed"
      }_${tempService.serviceType || "unspecified"}`;
    }

    if (!tempService.service_name || tempService.quantity <= 0) {
      alert("Please enter a service name and a valid quantity greater than 0.");
      setIsAddingService(false);
      return;
    }

    if (isManual && editIndex === null) {
      try {
        const serviceData = {
          serviceName: tempService.service_name,
          serviceType: tempService.serviceType || "Common (All Brands)",
          basePrice: roundTo2(tempService.basePrice),
          GST_tax: roundTo2(tempService.tax_percentage),
          hsnCode: tempService.hsnCode || "",
          description: tempService.description || "",
          category: "",
        };

        const response = await axios.post(`${Apiurl}/service`, serviceData);
        tempService.service_id = response.data._id;
        setServices((prev) => [
          ...prev,
          {
            ...response.data,
            basePrice: roundTo2(response.data.basePrice),
            GST_tax: roundTo2(response.data.GST_tax),
          },
        ]);
      } catch (error) {
        console.error("Error adding new service:", error);
        alert(
          `Failed to add new service: ${
            error.response?.data?.message || error.message
          }`,
        );
        setIsAddingService(false);
        return;
      }
    }

    const basePriceExclTax = roundTo2(
      tempService.basePrice / (1 + tempService.tax_percentage / 100),
    );
    const taxPerUnit = roundTo2(tempService.basePrice - basePriceExclTax);
    const totalTax = roundTo2(taxPerUnit * tempService.quantity);

    const updatedService = {
      ...tempService,
      basePriceExclTax,
      cgst: roundTo2(totalTax / 2),
      sgst: roundTo2(totalTax / 2),
      total: roundTo2(tempService.quantity * tempService.basePrice),
    };

    setSelectedServices((prev) => {
      if (editIndex !== null) {
        const updatedServices = [...prev];
        updatedServices[editIndex] = updatedService;
        return updatedServices;
      } else {
        const existingServiceIndex = prev.findIndex(
          (item) => item.service_id === tempService.service_id,
        );

        if (existingServiceIndex !== -1) {
          const updatedServices = [...prev];
          updatedServices[existingServiceIndex].quantity +=
            tempService.quantity;
          updatedServices[existingServiceIndex].total = roundTo2(
            updatedServices[existingServiceIndex].quantity *
              updatedServices[existingServiceIndex].basePrice,
          );
          updatedServices[existingServiceIndex].basePriceExclTax = roundTo2(
            updatedServices[existingServiceIndex].basePrice /
              (1 + updatedServices[existingServiceIndex].tax_percentage / 100),
          );

          const taxPerUnit = roundTo2(
            updatedServices[existingServiceIndex].basePrice -
              updatedServices[existingServiceIndex].basePriceExclTax,
          );
          const totalTax = roundTo2(
            taxPerUnit * updatedServices[existingServiceIndex].quantity,
          );
          updatedServices[existingServiceIndex].cgst = roundTo2(totalTax / 2);
          updatedServices[existingServiceIndex].sgst = roundTo2(totalTax / 2);
          return updatedServices;
        } else {
          return [...prev, updatedService];
        }
      }
    });

    setSelectedService({
      service_id: "",
      service_name: "",
      serviceType: "",
      basePrice: "",
      basePriceExclTax: 0,
      hsnCode: "",
      description: "",
      tax_percentage: "18",
      cgst: 0,
      sgst: 0,
      quantity: 1,
      total: 0,
    });
    setServiceSearch("");
    setShowServiceDropdown(false);
    setIsManual(false);
    setEditIndex(null);
    setIsAddingService(false);
  };

  const updateQuantity = (index, newQuantity) => {
    setSelectedServices((prev) => {
      const updatedServices = [...prev];
      const item = updatedServices[index];
      item.quantity = Math.max(parseInt(newQuantity) || 1, 1);
      item.basePriceExclTax = roundTo2(
        item.basePrice / (1 + (item.tax_percentage || 0) / 100),
      );
      const taxPerUnit = roundTo2(item.basePrice - item.basePriceExclTax);
      const totalTax = roundTo2(taxPerUnit * item.quantity);
      item.cgst = roundTo2(totalTax / 2);
      item.sgst = roundTo2(totalTax / 2);
      item.total = roundTo2(item.quantity * item.basePrice);
      return updatedServices;
    });
  };

  const updatePrice = (index, newPriceStr) => {
    const newPrice = roundTo2(parseFloat(newPriceStr) || 0);
    if (newPrice <= 0) return;

    setSelectedServices((prev) => {
      const updatedServices = [...prev];
      const item = updatedServices[index];
      item.basePrice = newPrice;
      item.basePriceExclTax = roundTo2(
        item.basePrice / (1 + (item.tax_percentage || 0) / 100),
      );
      const taxPerUnit = roundTo2(newPrice - item.basePriceExclTax);
      const totalTax = roundTo2(taxPerUnit * item.quantity);
      item.cgst = roundTo2(totalTax / 2);
      item.sgst = roundTo2(totalTax / 2);
      item.total = roundTo2(item.quantity * newPrice);
      return updatedServices;
    });
  };

  const updateGst = (index, newGstStr) => {
    const newGst = roundTo2(parseFloat(newGstStr) || 0);
    setSelectedServices((prev) => {
      const updatedServices = [...prev];
      const item = updatedServices[index];
      item.tax_percentage = newGst;
      item.basePriceExclTax = roundTo2(item.basePrice / (1 + newGst / 100));
      const taxPerUnit = roundTo2(item.basePrice - item.basePriceExclTax);
      const totalTax = roundTo2(taxPerUnit * item.quantity);
      item.cgst = roundTo2(totalTax / 2);
      item.sgst = roundTo2(totalTax / 2);
      item.total = roundTo2(item.quantity * item.basePrice);
      return updatedServices;
    });
  };

  const editService = (index) => {
    const item = selectedServices[index];
    setSelectedService(item);
    setServiceSearch(item.service_name);
    setShowServiceDropdown(false);
    setIsManual(true);
    setEditIndex(index);
  };

  const removeService = (index) => {
    setSelectedServices((prev) => prev.filter((_, i) => i !== index));
    if (editIndex === index) {
      setEditIndex(null);
      setSelectedService({
        service_id: "",
        service_name: "",
        serviceType: "",
        basePrice: "",
        basePriceExclTax: 0,
        hsnCode: "",
        description: "",
        tax_percentage: "18",
        cgst: 0,
        sgst: 0,
        quantity: 1,
        total: 0,
      });
      setServiceSearch("");
      setIsManual(false);
    }
  };

  const handleNewModelInputChange = (e) => {
    const { name, value } = e.target;
    setNewModelData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddModel = async (e) => {
    e.preventDefault();
    if (!newModelData.modelName.trim()) {
      alert("Model name is required.");
      return;
    }
    if (!newModelData.brand) {
      alert("Brand is required.");
      return;
    }

    try {
      const modelData = {
        model_name: newModelData.modelName.trim(),
        brand_name: newModelData.brand,
        status: newModelData.modelStatus,
      };

      await axios.post(`${Apiurl}/model`, modelData);
      setFormData((prev) => ({ ...prev, model: newModelData.modelName }));
      setShowAddModelModal(false);
      setNewModelData({
        modelName: "",
        brand: formData.brand,
        year: "",
        specifications: "",
        modelStatus: "Active",
      });

      if (formData.brand === newModelData.brand) {
        const response = await axios.get(
          `${Apiurl}/model?brand_name=${encodeURIComponent(formData.brand)}`,
        );
        setModels(
          response.data.filter((model) => model.brand_name === formData.brand),
        );
      }
    } catch (error) {
      console.error("Error adding model:", error);
      alert(
        `Failed to add model: ${error.response?.data?.message || error.message}`,
      );
    }
  };

  const handleCloseAddModelModal = () => {
    setShowAddModelModal(false);
    setNewModelData({
      modelName: "",
      brand: formData.brand,
      year: "",
      specifications: "",
      modelStatus: "Active",
    });
  };

  const fetchBillData = async () => {
    if (!formData.ref_no) {
      alert("Please enter a Previous Bill No to fetch data.");
      return;
    }

    try {
      setIsLoading(true);
      setError("");
      const response = await axios.get(
        `${Apiurl}/generalbill_ref/${formData.ref_no}`,
      );

      if (response.status === 200 && response.data) {
        const bill = response.data;
        const modelValue =
          typeof bill.model === "object"
            ? bill.model.model_name
            : bill.model || "";

        // Generate NEW bill number for this new bill
        const billNoResponse = await axios.get(`${Apiurl}/generate_billno`);
        const newBillNumber = billNoResponse.data.bill_no;
        setBillNo(newBillNumber);

        // Only fill customer & device info
        setFormData((prev) => ({
          ...prev,
          sale_date: new Date(bill.date || new Date())
            .toISOString()
            .split("T")[0],
          bill_no: newBillNumber,
          ref_no: formData.ref_no, // keep entered ref_no
          name: bill.name || "",
          mobile_no: bill.mobile_no || "",
          reasons: bill.reasons || "", // Address
          brand: bill.brand || "",
          model: modelValue,
          imei: bill.imei || "",
          technician: bill.technician || "",
          payment_type: bill.Paytype || "",
          // DO NOT touch payment fields
          advance_amount: "",
          cash: "",
          sub_total: 0,
          gst_amount: 0,
          net_total: 0,
          paid: 0,
          balance: 0,
        }));

        // Load models if brand exists
        if (bill.brand) {
          const modelRes = await axios.get(
            `${Apiurl}/model?brand_name=${encodeURIComponent(bill.brand)}`,
          );
          setModels(modelRes.data.filter((m) => m.brand_name === bill.brand));
        }

        // Clear services & payments
        setSelectedServices([]);
        setPreviousPaid(0);
        setCurrentPaid(0);
        setIsFetched(true); // optional flag
        alert(
          "Customer details loaded successfully! You can now add new services.",
        );
      } else {
        alert("No bill found with that reference number.");
      }
    } catch (error) {
      console.error("Error fetching bill:", error);
      alert("Bill not found or error occurred.");
      setError("Failed to fetch bill data.");
    } finally {
      setIsLoading(false);
    }
  };

  // save and print -- final (Updated with new logic)
  const handleSubmit = async () => {
    if (!formData.payment_type) {
      alert("Please select a Payment Type");
      return;
    }

    const advanceAmount = roundTo2(parseFloat(formData.advance_amount) || "");
    const cashAmount = roundTo2(parseFloat(formData.cash) || "");
    const netTotal = roundTo2(formData.net_total);
    let FinalAmt = roundTo2(Number(formData.payment?.[0]?.amount || 0));

    let currentTotal;
    if (isFetched) {
      // For fetched bills → cash only
      currentTotal = cashAmount > 0 ? cashAmount : formData.balance;
    } else {
      // For new bills → use new logic when both advance and cash are present
      if (advanceAmount > 0 && cashAmount > 0) {
        // NEW LOGIC: Add both advance and cash
        currentTotal = roundTo2(advanceAmount + cashAmount);
        FinalAmt = netTotal - roundTo2(advanceAmount + cashAmount);
      } else {
        // Old logic: advance only
        currentTotal = advanceAmount > 0 ? advanceAmount : netTotal;
      }
    }

    if (
      currentTotal < 0 ||
      (isFetched ? cashAmount : advanceAmount) > netTotal
    ) {
      alert("Payment amount cannot exceed net total.");
      return;
    }

    // Apply NEW LOGIC for final calculations
    let updatedPaid, updatedBalance;

    if (advanceAmount > 0 && cashAmount > 0) {
      // NEW LOGIC: Add advance + cash
      updatedPaid = roundTo2(advanceAmount + cashAmount);
      updatedBalance = roundTo2(netTotal - updatedPaid);
    } else {
      // Old logic
      updatedPaid = roundTo2(previousPaid + currentTotal);
      updatedBalance = roundTo2(netTotal - updatedPaid);
    }

    // Store for display
    setCurrentPaid(currentTotal);
    setFormData((prev) => ({
      ...prev,
      cash: cashAmount,
      advance_amount: isFetched ? prev.advance_amount : advanceAmount,
      paid: updatedPaid,
      balance: updatedBalance < 0 ? 0 : updatedBalance,
    }));

    if (isSubmitting) return;
    if (!formData.bill_no || !formData.name || selectedServices.length === 0) {
      alert(
        "Please fill in bill number, customer name, and select at least one service.",
      );
      return;
    }

    if (!formData.payment_type) {
      alert("Please select a Payment Type");
      return;
    }

    setIsSubmitting(true);

    try {
      const totalPaid = updatedPaid;
      const finalBalance = roundTo2(netTotal - totalPaid);
      const refNumber = formData.ref_no || formData.bill_no;

      const payments = [];
      if (currentTotal > 0 || advanceAmount > 0 || cashAmount > 0) {
        // NEW LOGIC for payment calculation
        let paymentAmount;
        let paymentBalance;

        if (advanceAmount > 0 && cashAmount > 0) {
          // NEW LOGIC: When both advance and cash are present
          // amount = advance + cash (what was paid in this transaction)
          paymentAmount = roundTo2(advanceAmount + cashAmount + finalBalance);
          // balance = remaining balance after this payment
          paymentBalance = finalBalance === paymentAmount ? "0" : "0";
        } else {
          // Old logic
          paymentAmount = currentTotal - cashAmount;
          paymentBalance = finalBalance < 0 ? 0 : finalBalance;
        }

        // payments.push({
        //   bill_no: formData.bill_no,
        //   date: formData.sale_date,
        //   total_amount: netTotal,
        //   payment_type: formData.payment_type,
        //   paid: finalBalance <= 0,
        //   amount: paymentAmount,
        //   balance: paymentBalance,
        // });

        if (advanceAmount > 0 && cashAmount > 0) {
          // ✅ YOUR REQUIRED LOGIC

          payments.push({
            bill_no: formData.bill_no,
            date: formData.sale_date,
            total_amount: netTotal,
            payment_type: formData.payment_type, // 👈 selected type
            paid: true,
            // amount: roundTo2(netTotal),
            amount: roundTo2(FinalAmt),
            balance: 0, // ✅ always ZERO
          });
        } else if (advanceAmount > 0) {
          const finalPayAmount = roundTo2(netTotal - advanceAmount);

          payments.push({
            bill_no: formData.bill_no,
            date: formData.sale_date,
            total_amount: roundTo2(netTotal),
            payment_type: formData.payment_type,
            paid: true,
            amount: finalPayAmount,
            balance: 0,
          });
        } else if (currentTotal > 0) {
          // 🔁 old logic for other cases

          // payments.push({
          //   bill_no: formData.bill_no,
          //   date: formData.sale_date,
          //   total_amount: netTotal,
          //   payment_type: formData.payment_type,
          //   paid: finalBalance <= 0,
          //   amount: currentTotal,
          //   balance: finalBalance < 0 ? 0 : finalBalance,
          // });

          payments.push({
            bill_no: formData.bill_no,
            date: formData.sale_date,
            total_amount: netTotal,
            payment_type: formData.payment_type,
            paid: finalBalance <= 0,
            amount: paymentAmount,
            balance: paymentBalance,
          });
        }
      }

      const billData = {
        bill_no: formData.bill_no,
        ref_no: refNumber,
        name: formData.name,
        mobile_no: formData.mobile_no,
        brand: formData.brand,
        model: formData.model,
        imei: formData.imei,
        date: formData.sale_date,
        reasons: formData.reasons,
        technician: formData.technician,
        advance_amount: isFetched ? formData.advance_amount : advanceAmount,
        cash: cashAmount,
        Paytype: formData.payment_type,
        gstin: formData.gstin || "0",
        sub_total: roundTo2(formData.sub_total),
        net_total: netTotal,
        gst_amount: roundTo2(formData.gst_amount),
        bill_staff: billStaff,
        paid: totalPaid,
        balance: finalBalance < 0 ? 0 : finalBalance,
        service_list: selectedServices.map((item) => ({
          bill_no: formData.bill_no,
          serviceName: item.service_name,
          serviceType: item.serviceType,
          basePrice: roundTo2(item.basePriceExclTax),
          hsnCode: item.hsnCode,
          description: item.description,
          tax_percentage: roundTo2(item.tax_percentage),
          quantity: item.quantity,
        })),
        payment: payments,
      };

      console.log("Submitting bill data:", billData);
      const res = await axios.post(`${Apiurl}/generalbill`, billData);
      console.log("Bill submitted:", res.data);

      if (res.status === 200 || res.status === 201) {
        // reset
        setSelectedServices([]);
        setFormData({
          sale_date: new Date().toISOString().split("T")[0],
          bill_no: "",
          ref_no: "",
          name: "",
          mobile_no: "",
          brand: "",
          model: "",
          imei: "",
          reasons: "",
          technician: "",
          advance_amount: "",
          cash: "",
          payment_type: "",
          gstin: "",
          sub_total: 0,
          gst_amount: 0,
          net_total: 0,
          paid: 0,
          balance: 0,
          bill_staff: billStaff,
        });
        setServiceSearch("");
        setModels([]);
        setIsFetched(false);
        setPreviousPaid(0);
        setCurrentPaid(0);
        // print
        // window.open(`/invoice-bill/${formData.bill_no}`, "_self");
        window.open(`/invoice-bill/${res.data.bill_no}`, "_self");
      }
    } catch (err) {
      console.error("Error:", err);
      alert(
        `Failed to submit bill: ${err.response?.data?.message || err.message}`,
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClearOverAll = async () => {
    try {
      const response = await axios.get(`${Apiurl}/generate_billno`);
      setFormData({
        sale_date: new Date().toISOString().split("T")[0],
        bill_no: response.data.bill_no || `BILL-${Date.now()}`,
        ref_no: "",
        name: "",
        mobile_no: "",
        brand: "",
        model: "",
        imei: "",
        reasons: "",
        technician: "",
        advance_amount: "",
        cash: "",
        payment_type: "",
        gstin: "",
        sub_total: 0,
        gst_amount: 0,
        net_total: 0,
        paid: 0,
        balance: 0,
        bill_staff: billStaff,
      });
      setSelectedServices([]);
      setServiceSearch("");
      setSelectedService({
        service_id: "",
        service_name: "",
        serviceType: "",
        basePrice: "",
        basePriceExclTax: 0,
        hsnCode: "",
        description: "",
        tax_percentage: "18",
        cgst: 0,
        sgst: 0,
        quantity: 1,
        total: 0,
      });
      setSelectedBrand("");
      setModels([]);
      setIsFetched(false);
      setPreviousPaid(0);
      setCurrentPaid(0);
      setEditIndex(null);
    } catch (error) {
      alert("Failed to fetch new bill number.");
    }
  };

  const handleCancel = () => {
    navigate("/bill/general");
  };

  return (
    <>
      <style>
        {`
          .form-control, .form-select {
            border: 1px solid #00000086 !important;
          }
          .input-group .form-control {
            border-right: none !important;
          }
          .input-group .btn {
            border: 1px solid #00000086 !important;
          }
          .table-scroll-350 {
            max-height: 350px;
            overflow-y: auto;
          }
        `}
      </style>
      <div className="p-3" style={{ overflow: "hidden" }}>
        {error && <div className="alert alert-danger">{error}</div>}
        {isLoading && <div className="alert alert-info">Loading...</div>}
        <div className="row">
          <div className="col-lg-9 col-xl-9">
            <div className="card p-2">
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-3">
                      <label className="mb-1 fw-bold">Customer Name</label>
                      <input
                        className="form-control"
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="Enter Customer Name"
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="fw-bold">Pay Type</label>
                      <select
                        className="form-select form-control-sm"
                        name="payment_type"
                        value={formData.payment_type}
                        onChange={handleInputChange}
                      >
                        <option value="">-- Select PayType --</option>
                        <option value="Phonepe">Phonepe</option>
                        <option value="Cash">Cash</option>
                        <option value="Card">Card</option>
                        <option value="Bank Transfer">Bank Transfer</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label className="mb-1 fw-bold">Mobile No</label>
                      <input
                        className="form-control"
                        type="text"
                        name="mobile_no"
                        value={formData.mobile_no}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,10}$/.test(value)) {
                            setFormData((prev) => ({
                              ...prev,
                              mobile_no: value,
                            }));
                          }
                        }}
                        placeholder="Enter Mobile Number"
                        maxLength={10}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="mb-1 fw-bold">Address</label>
                      <input
                        className="form-control"
                        name="reasons"
                        value={formData.reasons}
                        onChange={handleInputChange}
                        placeholder="Enter Address"
                      />
                    </div>
                    <div className="col-md-3 mb-2">
                      <label className="mb-1 fw-bold">Brand</label>
                      <select
                        className="form-select"
                        name="brand"
                        value={formData.brand}
                        onChange={handleInputChange}
                      >
                        <option value="">-- Select Brand --</option>
                        {brands.map((brand) => (
                          <option key={brand._id} value={brand.brand_name}>
                            {brand.brand_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-3 mb-2">
                      <label className="mb-1 fw-bold">Model</label>
                      <div className="input-group">
                        <select
                          id="model"
                          className="form-select"
                          name="model"
                          placeholder="Model"
                          value={formData.model}
                          onChange={handleInputChange}
                          disabled={!formData.brand}
                        >
                          <option value="">-- Select Model --</option>
                          {models.map((model) => (
                            <option key={model._id} value={model.model_name}>
                              {model.model_name}
                            </option>
                          ))}
                        </select>
                        <button
                          className="btn btn-primary"
                          type="button"
                          onClick={() => {
                            setNewModelData((prev) => ({
                              ...prev,
                              brand: formData.brand,
                            }));
                            setShowAddModelModal(true);
                          }}
                          disabled={!formData.brand}
                        >
                          +
                        </button>
                      </div>
                    </div>
                    <div className="col-md-3 mb-2">
                      <label className="mb-1 fw-bold">IMEI</label>
                      <input
                        className="form-control"
                        type="tel"
                        name="imei"
                        value={formData.imei}
                        onChange={(e) => {
                          const value = e.target.value
                            .replace(/\D/g, "")
                            .slice(0, 15);
                          handleInputChange({
                            target: { name: "imei", value },
                          });
                        }}
                        placeholder="Enter IMEI Number"
                        maxLength={15}
                      />
                    </div>
                    <div className="col-md-3 mb-2">
                      <label className="mb-1 fw-bold">Technician</label>
                      <select
                        className="form-select"
                        name="technician"
                        value={formData.technician}
                        onChange={handleInputChangeStaff}
                      >
                        <option value="">-- Select Technician --</option>
                        {staff
                          .filter((person) => person.role === "Technician")
                          .map((person) => (
                            <option key={person._id} value={person.full_name}>
                              {person.full_name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row p-2">
              <div className="border rounded p-3 bg-white">
                {!isManual ? (
                  <div className="row mb-2">
                    <div className="col-md-4 col-lg-4 col-xl-4 position-relative">
                      <label className="form-label fw-bold">Service Name</label>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          value={serviceSearch}
                          onChange={handleServiceSearchChange}
                          onFocus={() => setShowServiceDropdown(true)}
                          placeholder="Enter Service Name"
                        />
                        {/* <button
                          className="btn btn-primary d-flex justify-content-center align-items-center"
                          style={{ height: "32px" }}
                          type="button"
                          onClick={() => {
                            setIsManual(true);
                            setShowServiceDropdown(false);
                            setSelectedService({
                              service_id: "",
                              service_name: "",
                              serviceType: "",
                              basePrice: "",
                              basePriceExclTax: 0,
                              hsnCode: "",
                              description: "",
                              tax_percentage: "18",
                              cgst: 0,
                              sgst: 0,
                              quantity: 1,
                              total: 0,
                            });
                            setServiceSearch("");
                            setEditIndex(null);
                          }}
                        >
                          +
                        </button> */}
                        <button
                          className="btn btn-primary d-flex justify-content-center align-items-center"
                          style={{ height: "32px", minWidth: "38px" }}
                          type="button"
                          onClick={() => {
                            setShowAddService(true);
                            // Optional: reset selected service for fresh entry
                            setSelectedService({
                              service_id: "",
                              service_name: "",
                              serviceType: "",
                              basePrice: "",
                              basePriceExclTax: 0,
                              hsnCode: "",
                              description: "",
                              tax_percentage: "18",
                              cgst: 0,
                              sgst: 0,
                              quantity: 1,
                              total: 0,
                            });
                            setServiceSearch("");
                            setIsManual(true); // ← important for addServiceToTable logic
                            setEditIndex(null);
                          }}
                        >
                          +
                        </button>
                      </div>
                      {/* {showServiceDropdown && filteredServices.length > 0 && (
                        <ul
                          className="list-group position-absolute w-100"
                          style={{
                            zIndex: 1000,
                            maxHeight: "200px",
                            overflowY: "auto",
                            top: "100%",
                            left: 0,
                          }}
                        >
                          {filteredServices.map((service) => (
                            <li
                              key={service._id}
                              className="list-group-item list-group-item-action"
                              style={{ cursor: "pointer" }}
                              onClick={() => selectService(service)}
                            >
                              {service.serviceName} <br />({service.hsnCode}/{" "}
                              {service.basePrice.toFixed(2)}/{" "}
                              {service.GST_tax.toFixed(2)}%)
                            </li>
                          ))}
                        </ul>
                      )} */}

                      {showServiceDropdown && filteredServices.length > 0 && (
                        <ul
                          className="list-group position-absolute w-100 shadow"
                          style={{
                            zIndex: 1000,
                            maxHeight: "240px",
                            overflowY: "auto",
                            top: "100%",
                            left: 0,
                            backgroundColor: "white",
                          }}
                        >
                          {filteredServices.map((service) => (
                            <li
                              key={service._id}
                              className="list-group-item list-group-item-action small py-2"
                              style={{ cursor: "pointer" }}
                              onClick={() => selectService(service)}
                            >
                              <strong>{service.serviceName}</strong>
                              <br />
                              <small className="text-muted">
                                {service.hsnCode} • ₹
                                {service.basePrice.toFixed(2)} •{" "}
                                {service.GST_tax}%
                              </small>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                    <div className="col-md-1 col-lg-1 col-xl-1">
                      <label className="form-label fw-bold">Qty</label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        name="quantity"
                        value={selectedService.quantity}
                        onChange={handleServiceInputChange}
                        placeholder="Quantity"
                        min="1"
                      />
                    </div>
                    <div className="col-md-2 col-lg-2">
                      <label className="form-label fw-bold">HSN Code</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="hsnCode"
                        value={selectedService.hsnCode}
                        onChange={handleServiceInputChange}
                        placeholder="HSN Code"
                      />
                    </div>
                    <div className="col-md-2 col-lg-2 col-xl-2">
                      <label className="form-label fw-bold">
                        Price (Inc. GST)
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="basePrice"
                        value={selectedService.basePrice}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*\.?\d*$/.test(value)) {
                            handleServiceInputChange(e);
                          }
                        }}
                        placeholder="Price"
                      />
                    </div>
                    <div className="col-md-1 col-lg-1 col-xl-1">
                      <label className="form-label fw-bold">GST %</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="tax_percentage"
                        value={selectedService.tax_percentage}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*\.?\d*$/.test(value)) {
                            handleServiceInputChange(e);
                          }
                        }}
                        placeholder="GST %"
                      />
                    </div>
                    <div className="col-md-1 col-lg-1 col-xl-1 mt-4">
                      <button
                        type="button"
                        className="btn btn-sm btn-success mt-2 w-100"
                        onClick={addServiceToTable}
                        disabled={isAddingService}
                      >
                        +
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label className="form-label fw-bold">Service Name</label>
                      <div className="d-flex">
                        <input
                          type="text"
                          className="form-control form-control-sm flex-grow-1"
                          name="service_name"
                          value={selectedService.service_name}
                          onChange={handleServiceInputChange}
                          placeholder="Enter Service Name"
                        />
                        <button
                          className="btn btn-sm btn-outline-secondary ms-1 d-flex align-items-center justify-content-center"
                          style={{
                            width: "30px",
                            height: "30px",
                            padding: 0,
                            fontWeight: "bold",
                            fontSize: "14px",
                            lineHeight: "1",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            transition: "all 0.2s ease-in-out",
                          }}
                          onClick={() => {
                            setIsManual(false);
                            setSelectedService({
                              service_id: "",
                              service_name: "",
                              serviceType: "",
                              basePrice: "",
                              basePriceExclTax: 0,
                              hsnCode: "",
                              description: "",
                              tax_percentage: "18",
                              cgst: 0,
                              sgst: 0,
                              quantity: 1,
                              total: 0,
                            });
                            setServiceSearch("");
                            setShowServiceDropdown(false);
                            setEditIndex(null);
                          }}
                          title="Exit Manual Mode"
                        >
                          ×
                        </button>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label fw-bold">HSN</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="hsnCode"
                        value={selectedService.hsnCode}
                        onChange={handleServiceInputChange}
                        placeholder="HSN Code"
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label fw-bold">Qty</label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        name="quantity"
                        value={selectedService.quantity}
                        onChange={handleServiceInputChange}
                        placeholder="Qty"
                        min="1"
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label fw-bold">
                        Price (Inc. GST)
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="basePrice"
                        value={selectedService.basePrice}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*\.?\d*$/.test(value)) {
                            handleServiceInputChange(e);
                          }
                        }}
                        placeholder="Price"
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label fw-bold">GST %</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        name="tax_percentage"
                        value={selectedService.tax_percentage}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*\.?\d*$/.test(value)) {
                            handleServiceInputChange(e);
                          }
                        }}
                        placeholder="Tax %"
                      />
                    </div>
                    <div className="col-md-1 mt-4">
                      <button
                        type="button"
                        className="btn btn-sm btn-success w-100"
                        onClick={addServiceToTable}
                        disabled={isAddingService}
                      >
                        +
                      </button>
                    </div>
                  </div>
                )}
                <div className="table-responsive table-scroll-350">
                  <table className="table table-bordered mb-0">
                    <thead className="text-center">
                      <tr>
                        {[
                          "S.No",
                          "Description",
                          "HSN",
                          "Qty",
                          "Rate (Excl. GST)",
                          "GST %",
                          "GST Amt",
                          "Amt (Inc. Tax)",
                          "Action",
                        ].map((h, idx) => (
                          <th
                            key={idx}
                            style={{
                              backgroundColor: "#2e9290",
                              color: "white",
                            }}
                          >
                            {h}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="text-center">
                      {selectedServices.length > 0 ? (
                        selectedServices.map((item, index) => (
                          <tr key={item.service_id}>
                            <td>{index + 1}</td>
                            <td>{item.service_name || "N/A"}</td>
                            <td>{item.hsnCode || "N/A"}</td>
                            <td>
                              <input
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                className="form-control form-control-sm text-center"
                                style={{ width: "60px" }}
                                value={item.quantity}
                                onChange={(e) => {
                                  const value = e.target.value.replace(
                                    /[^0-9]/g,
                                    "",
                                  );
                                  updateQuantity(index, parseInt(value) || 0);
                                }}
                                placeholder="0"
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                inputMode="decimal"
                                pattern="[0-9.]*"
                                className="form-control form-control-sm text-center"
                                style={{ width: "80px" }}
                                value={item.basePriceExclTax.toFixed(2)}
                                onChange={(e) => {
                                  const value = e.target.value.replace(
                                    /[^0-9.]/g,
                                    "",
                                  );
                                  const newPriceExclTax = roundTo2(
                                    parseFloat(value) || 0,
                                  );
                                  const newPrice = roundTo2(
                                    newPriceExclTax *
                                      (1 + (item.tax_percentage || 0) / 100),
                                  );
                                  updatePrice(index, newPrice.toString());
                                }}
                                placeholder="0.00"
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                inputMode="decimal"
                                pattern="[0-9.]*"
                                className="form-control form-control-sm text-center"
                                style={{ width: "60px" }}
                                value={item.tax_percentage}
                                onChange={(e) => {
                                  const value = e.target.value.replace(
                                    /[^0-9.]/g,
                                    "",
                                  );
                                  updateGst(index, value);
                                }}
                                placeholder="0"
                              />
                            </td>
                            <td>
                              {roundTo2(item.cgst + item.sgst).toFixed(2)}
                            </td>
                            <td>{item.total.toFixed(2)}</td>
                            <td className="d-flex justify-content-center gap-1">
                              <button
                                className="btn btn-sm p-1 border-0"
                                style={{ backgroundColor: "transparent" }}
                                onClick={() => editService(index)}
                              >
                                <Edit size={16} className="text-primary" />
                              </button>
                              <button
                                className="btn btn-sm p-1 border-0"
                                style={{ backgroundColor: "transparent" }}
                                onClick={() => removeService(index)}
                              >
                                <Trash2 size={16} className="text-danger" />
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No services selected
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-xl-3">
            <div className="card">
              <div className="card-body py-1 px-3">
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <label className="mb-1 fw-bold">Date</label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      name="sale_date"
                      value={formData.sale_date}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <label className="mb-1 fw-bold">Bill No</label>
                    <input
                      className="form-control form-control-sm"
                      type="text"
                      name="bill_no"
                      value={formData.bill_no}
                      onChange={handleInputChange}
                      readOnly
                      placeholder="Bill Number"
                    />
                  </div>
                  {/* <div className="col-lg-11 col-md-11">
                    <label className="mb-1 fw-bold">Previous Bill No</label>
                    <div className="input-group">
                      <input
                        className="form-control form-control-sm"
                        type="text"
                        name="ref_no"
                        value={formData.ref_no}
                        onChange={handleInputChange}
                        placeholder="Previous Bill No"
                      />
                      <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        style={{ height: "31px" }}
                        onClick={fetchBillData}
                      >
                        <FaSearch />
                      </button>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="card mt-2 p-2">
              <div className="card-body py-1 px-3">
                <div className="row">
                  <div className="col-5">
                    <label className="fw-bold">Sub Total</label>
                  </div>
                  <div className="col-7">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={formData.sub_total.toFixed(2)}
                      readOnly
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-5">
                    <label className="fw-bold">GST</label>
                  </div>
                  <div className="col-7">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={formData.gst_amount.toFixed(2)}
                      readOnly
                      placeholder="Tax Amount"
                    />
                  </div>
                </div>
                <div
                  className="row mt-2 p-2"
                  style={{ backgroundColor: "#2e9290" }}
                >
                  <div className="col-12">
                    <div className="d-flex justify-content-between align-items-center">
                      <label className="fs-5 text-white fw-bold mb-0">
                        Net Total
                      </label>
                      <input
                        type="text"
                        className="form-control text-end fs-4 fw-bold text-primary mt-3"
                        style={{ width: "63%" }}
                        value={Math.round(formData.net_total).toFixed(2)}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-6">
                    <label className="fw-bold">Advance</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="advance_amount"
                      value={formData.advance_amount}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d*$/.test(value)) {
                          handleInputChange(e);
                        }
                      }}
                      placeholder="Advance Amount"
                      disabled={isFetched}
                    />
                  </div>
                  <div className="col-6">
                    <label className="fw-bold">Cash</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="cash"
                      value={formData.cash}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d*$/.test(value)) {
                          handleInputChange(e);
                        }
                      }}
                      placeholder="Cash"
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-5">
                    <label className="fw-bold">Paid</label>
                  </div>
                  <div className="col-7">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={Math.round(formData.paid).toFixed(2)}
                      readOnly
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-5">
                    <label className="fw-bold">Balance</label>
                  </div>
                  <div className="col-7">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={Math.round(formData.balance).toFixed(2)}
                      readOnly
                    />
                  </div>
                </div>
                <div className="row text-center mb-3">
                  <div className="col-3">
                    <button
                      className="btn btn-sm btn-secondary w-auto"
                      onClick={handleClearOverAll}
                    >
                      Clear
                    </button>
                  </div>
                  <div className="col-6">
                    <button
                      className="btn btn-sm btn-success w-auto"
                      onClick={handleSubmit}
                      disabled={isSubmitting}
                    >
                      Save & Print
                    </button>
                  </div>
                  <div className="col-3">
                    <button
                      className="btn btn-sm btn-danger w-auto"
                      onClick={handleCancel}
                    >
                      Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade ${showAddModelModal ? "show d-block" : ""}`}
        tabIndex="-1"
        aria-labelledby="addModelModalLabel"
        aria-hidden={!showAddModelModal}
        style={{
          backgroundColor: "rgba(0,0,0,0.5)",
          transition: "opacity 0.3s ease-in-out",
          display: showAddModelModal ? "block" : "none",
        }}
      >
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0">
              <h5 className="modal-title" id="addModelModalLabel">
                Add Model
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleCloseAddModelModal}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleAddModel}>
                <div className="mb-3">
                  <label className="form-label fw-bold">Model Name</label>
                  <input
                    type="text"
                    name="modelName"
                    className="form-control"
                    value={newModelData.modelName}
                    onChange={handleNewModelInputChange}
                    placeholder="e.g., Nord 2"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Brand</label>
                  <select
                    name="brand"
                    className="form-select"
                    value={newModelData.brand}
                    onChange={handleNewModelInputChange}
                    required
                  >
                    <option value="">Select Brand</option>
                    {brands.map((brand) => (
                      <option key={brand._id} value={brand.brand_name}>
                        {brand.brand_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label fw-bold">Status</label>
                  <select
                    name="modelStatus"
                    className="form-select"
                    value={newModelData.modelStatus}
                    onChange={handleNewModelInputChange}
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>
                <div className="d-flex justify-content-end gap-2">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCloseAddModelModal}
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    style={{ backgroundColor: "#2e9290", border: "none" }}
                  >
                    Add Model
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Add Service Popup  */}
      <div
        className={`modal fade ${showAddService ? "show" : ""}`}
        style={{
          display: showAddService ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {editIndex !== null ? "Edit Service" : "Add New Service"}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  setShowAddService(false);
                  setIsManual(false);
                  setEditIndex(null);
                }}
              ></button>
            </div>

            <div className="modal-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label fw-bold">
                    Service Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="service_name"
                    value={selectedService.service_name || ""}
                    onChange={handleServiceInputChange}
                    placeholder="Enter service name"
                    required
                  />
                </div>

                <div className="col-md-3">
                  <label className="form-label fw-bold">HSN Code</label>
                  <input
                    type="text"
                    className="form-control"
                    name="hsnCode"
                    value={selectedService.hsnCode || ""}
                    onChange={handleServiceInputChange}
                    placeholder="e.g. 9983"
                  />
                </div>

                <div className="col-md-3">
                  <label className="form-label fw-bold">Quantity</label>
                  <input
                    type="number"
                    className="form-control"
                    name="quantity"
                    value={selectedService.quantity}
                    onChange={handleServiceInputChange}
                    min="1"
                    required
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-bold">Price (Inc. GST)</label>
                  <input
                    type="text"
                    className="form-control"
                    name="basePrice"
                    value={selectedService.basePrice}
                    onChange={(e) => {
                      if (/^\d*\.?\d*$/.test(e.target.value)) {
                        handleServiceInputChange(e);
                      }
                    }}
                    placeholder="0.00"
                    required
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-bold">GST %</label>
                  <input
                    type="text"
                    className="form-control"
                    name="tax_percentage"
                    value={selectedService.tax_percentage}
                    onChange={(e) => {
                      if (/^\d*\.?\d*$/.test(e.target.value)) {
                        handleServiceInputChange(e);
                      }
                    }}
                    placeholder="18"
                  />
                </div>

                {/* <div className="col-md-4">
                  <label className="form-label fw-bold">Total Amount</label>
                  <input
                    type="text"
                    className="form-control bg-light"
                    value={(selectedService.total || 0).toFixed(2)}
                    readOnly
                  />
                </div> */}
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  setShowAddService(false);
                  setIsManual(false);
                  setEditIndex(null);
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={() => {
                  addServiceToTable();
                  setShowAddService(false); // close modal after add
                }}
                disabled={
                  isAddingService ||
                  !selectedService.service_name ||
                  selectedService.quantity < 1
                }
              >
                {editIndex !== null ? "Update Service" : "Add Service"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Add_GeneralBill;
